var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoolveticaUlRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sun Sep  9 20:21:33 2018\n By Aleksey,,,\n(c) 1999-2018 Typodermic Fonts Inc.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "CoolveticaUl-Regular",
    horizAdvX: 604
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Coolvetica Ul",
    fontWeight: 250,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 2 3 3 6 2 2 0 4",
    ascent: 767,
    descent: -233,
    xHeight: 492,
    capHeight: 664,
    bbox: "-413 -233 1007 918",
    underlineThickness: 20,
    underlinePosition: -203,
    unicodeRange: "U+0017-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 452,
    d: "M322 0h-193q-97 0 -97 84v488q0 85 97 85h193q98 0 98 -85v-488q0 -84 -98 -84zM368 84v488q0 39 -46 39h-193q-46 0 -46 -39v-488q0 -39 46 -39h193q46 0 46 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 452,
    d: "M322 0h-193q-97 0 -97 84v488q0 85 97 85h193q98 0 98 -85v-488q0 -84 -98 -84zM368 84v488q0 39 -46 39h-193q-46 0 -46 -39v-488q0 -39 46 -39h193q46 0 46 39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0017",
    horizAdvX: 222
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 222
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 141,
    d: "M79 0h-17v71h17v-71zM75 130h-9q-3 160 -3 406v128h15v-128q0 -246 -3 -406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 286,
    d: "M78 414h-10v250h10v-250zM221 414h-10v250h10v-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 469,
    d: "M276 0h-11l26 226h-145l-26 -226h-11l26 226h-111l1 10h111l22 194h-112l1 10h112l27 224h11l-26 -224h144l27 224h11l-26 -224h110l-1 -10h-110l-23 -194h112l-1 -10h-112zM292 236l22 194h-144l-23 -194h145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 475,
    d: "M249 -55h-10v39q-100 2 -153.5 55t-56.5 157h10q4 -199 200 -202v328q-62 5 -102.5 18.5t-68 50t-27.5 96.5q0 77 48 124t150 48v43h10v-43q86 -2 135 -58t53 -150h-10q-5 91 -52 143.5t-126 54.5v-317q41 -3 65.5 -6.5t54.5 -14t46 -27t27 -46t11 -70.5 q0 -84 -55.5 -133t-148.5 -51v-39zM249 321v-327q89 2 141.5 48t52.5 126q0 47 -12.5 77t-41.5 45.5t-59 21.5t-81 9zM239 332v317q-98 -1 -143 -45t-45 -117q0 -45 14 -75t42.5 -46t57.5 -23t74 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 697,
    d: "M133 331q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5t-77.5 -45.5zM133 340q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171zM124 -20h-12l464 704h12zM566 -22q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5 t-77.5 -45.5zM566 -13q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 482,
    d: "M439 172v175h10v-175q0 -94 -57.5 -144.5t-153.5 -50.5t-150.5 50t-54.5 145q0 73 48 121.5t128 48.5q-75 2 -112.5 48.5t-37.5 107.5q0 80 52.5 123t149.5 43v-10q-91 0 -141.5 -40.5t-50.5 -115.5q0 -28 7 -52t24 -47.5t52.5 -37.5t85.5 -14h23v-10h-23 q-100 0 -147.5 -46t-47.5 -119q0 -90 52 -137.5t143 -47.5q92 0 146.5 47.5t54.5 137.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 143,
    d: "M78 414h-10v250h10v-250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 255,
    d: "M240 -143h-14q-69 93 -106.5 208.5t-37.5 235.5q0 246 144 427h14q-148 -180 -148 -427q0 -250 148 -444z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 255,
    d: "M37 -143h-14q148 194 148 444q0 247 -148 427h14q144 -181 144 -427q0 -120 -37.5 -235.5t-106.5 -208.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 514,
    d: "M393 269l-9 -6l-125 173l-125 -174l-9 7l127 173l-205 65l4 10l203 -67v214h9v-214l204 67l3 -10l-205 -65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 501,
    d: "M255 132h-10v207h-207v10h207v207h10v-207h207v-10h-207v-207z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 93,
    d: "M38 -67v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 279,
    d: "M251 304h-223v10h223v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "\xAD",
    horizAdvX: 279,
    d: "M251 304h-223v10h223v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 92,
    d: "M55 0h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 295,
    d: "M21 0h-11l259 664h11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 470,
    d: "M236 -23q-204 0 -204 358q0 351 204 351q207 0 207 -349q0 -181 -54 -270.5t-153 -89.5zM236 -13q94 0 145.5 87t51.5 263q0 339 -197 339q-194 0 -194 -341q0 -348 194 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 195,
    d: "M157 0h-10v539h-128v10h99q18 0 23.5 5.5t5.5 22.5v87h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 444,
    d: "M425 0h-406q0 94 45 159t166 135q49 28 68 40t48.5 34t40 38.5t19 42t8.5 56.5q0 88 -50 129.5t-133 41.5q-91 0 -142 -53.5t-52 -162.5v-10h-10q0 117 54 176.5t150 59.5q88 0 140.5 -44t52.5 -137q0 -28 -4 -50t-17.5 -42t-24 -32.5t-39 -31.5t-45.5 -29.5t-59 -34.5 q-114 -65 -159 -127t-47 -148h396v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 458,
    d: "M246 347h-64v10h64q44 0 77 15t50 40t25 51t8 53q0 74 -50 117t-126 43q-84 0 -133 -55t-49 -148h-10q0 97 50.5 155t141.5 58q80 0 133 -46t53 -124q0 -63 -36.5 -112.5t-111.5 -51.5q79 0 122.5 -48t43.5 -122q0 -96 -57.5 -150.5t-152.5 -54.5t-145.5 57.5 t-50.5 160.5h10q0 -98 49 -153t137 -55q91 0 145.5 52t54.5 143q0 72 -45 118.5t-133 46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 454,
    d: "M368 0h-10v177h-339v12l333 475h16v-477h67v-10h-67v-177zM358 187v468l-328 -468h328z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 470,
    d: "M52 171q7 -84 59 -134t129 -50q87 0 141.5 62.5t54.5 164.5q0 94 -49 146.5t-134 52.5q-67 0 -115.5 -32t-84.5 -120h-10l13 403h368v-10h-358l-13 -374q34 79 82.5 111t117.5 32q89 0 141 -55t52 -154q0 -107 -57 -172t-149 -65q-82 0 -138.5 54.5t-60.5 139.5h11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 467,
    d: "M426 520h-10q-10 78 -53 117t-110 39q-108 0 -160.5 -87t-52.5 -278q36 55 92 89t115 34q88 0 139 -58.5t51 -161.5t-54.5 -170t-142.5 -67q-210 0 -210 333q0 197 55 286.5t168 89.5q73 0 118.5 -43t54.5 -123zM40 295q5 -308 200 -308q83 0 135 64t52 163 q0 98 -48.5 154t-131.5 56q-59 0 -115.5 -35.5t-91.5 -93.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 456,
    d: "M164 0h-10q12 171 89.5 359t178.5 295h-403v10h418v-9q-104 -106 -183.5 -296t-89.5 -359z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 470,
    d: "M235 -23q-94 0 -149.5 54.5t-55.5 150.5q0 73 48 121.5t128 48.5q-75 2 -112.5 52t-37.5 112q0 79 49.5 124.5t129.5 45.5t129.5 -45.5t49.5 -124.5q0 -62 -37.5 -112t-112.5 -52q80 0 128 -48.5t48 -121.5q0 -96 -55.5 -150.5t-149.5 -54.5zM235 -13q90 0 142.5 51.5 t52.5 143.5q0 73 -47.5 119t-147.5 46t-147.5 -46t-47.5 -119q0 -92 52.5 -143.5t142.5 -51.5zM404 516q0 74 -47 117t-122 43t-122 -43t-47 -117q0 -28 7 -53t24 -50.5t52.5 -40.5t85.5 -15t85.5 15t52.5 40.5t24 50.5t7 53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 467,
    d: "M41 143h10q10 -78 53 -117t110 -39q108 0 160.5 87t52.5 278q-36 -55 -92 -89t-115 -34q-88 0 -139 58.5t-51 161.5t54.5 170t142.5 67q210 0 210 -333q0 -197 -55 -286.5t-168 -89.5q-73 0 -118.5 43t-54.5 123zM427 368q-5 308 -200 308q-83 0 -135 -64t-52 -163 q0 -98 48.5 -154t131.5 -56q59 0 115.5 35.5t91.5 93.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 77,
    d: "M46 0h-17v71h17v-71zM46 339h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 63,
    d: "M42 339h-17v71h17v-71zM25 -67v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 501,
    d: "M462 96l-424 242v10l424 242v-12l-414 -235l414 -235v-12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 501,
    d: "M462 440h-424v10h424v-10zM462 237h-424v10h424v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 501,
    d: "M462 338l-424 -242v12l414 235l-414 235v12l424 -242v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 471,
    d: "M242 131h-10v24q0 134 100 192q50 29 75.5 65t25.5 93q0 86 -52 128.5t-148 42.5q-87 0 -139.5 -54t-52.5 -151h-10q0 99 54 157t148 58q100 0 155 -45t55 -136q0 -59 -26.5 -97.5t-79.5 -69.5q-95 -55 -95 -183v-24zM245 0h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 671,
    d: "M593 -16l5 -9q-37 -27 -104 -42.5t-138 -15.5q-158 0 -242 94t-84 250q0 161 85.5 263t232.5 102q130 0 211.5 -73.5t81.5 -226.5q0 -136 -35 -193.5t-81 -57.5q-67 0 -67 107q0 22 1 32q-15 -56 -59.5 -97.5t-104.5 -41.5q-58 0 -89 48.5t-31 116.5q0 98 46.5 162 t122.5 64q124 0 126 -171l24 161h10l-32 -209q-4 -24 -4 -69q0 -93 57 -93q43 0 74.5 55t31.5 186q0 149 -79 219.5t-204 70.5q-142 0 -225 -99t-83 -256q0 -151 81.5 -242.5t234.5 -91.5q164 0 237 57zM295 85q69 0 118 58t49 152q0 161 -118 161q-71 0 -115 -61.5 t-44 -154.5q0 -64 28.5 -109.5t81.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0410",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "\u0391",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 525,
    d: "M287 0h-249v664h274q93 0 136.5 -40.5t43.5 -110.5q0 -74 -39 -113.5t-92 -40.5q58 -4 103.5 -45.5t45.5 -130.5q0 -87 -55 -135t-168 -48zM48 10h239q108 0 160.5 45.5t52.5 127.5q0 88 -46.5 129.5t-128.5 41.5h-277v-344zM48 364h277q157 0 157 149q0 65 -41 103 t-129 38h-264v-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0412",
    horizAdvX: 525,
    d: "M287 0h-249v664h274q93 0 136.5 -40.5t43.5 -110.5q0 -74 -39 -113.5t-92 -40.5q58 -4 103.5 -45.5t45.5 -130.5q0 -87 -55 -135t-168 -48zM48 10h239q108 0 160.5 45.5t52.5 127.5q0 88 -46.5 129.5t-128.5 41.5h-277v-344zM48 364h277q157 0 157 149q0 65 -41 103 t-129 38h-264v-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "\u0392",
    horizAdvX: 525,
    d: "M287 0h-249v664h274q93 0 136.5 -40.5t43.5 -110.5q0 -74 -39 -113.5t-92 -40.5q58 -4 103.5 -45.5t45.5 -130.5q0 -87 -55 -135t-168 -48zM48 10h239q108 0 160.5 45.5t52.5 127.5q0 88 -46.5 129.5t-128.5 41.5h-277v-344zM48 364h277q157 0 157 149q0 65 -41 103 t-129 38h-264v-290z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "\u0421",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 575,
    d: "M288 0h-250v664h231q123 0 200 -88t77 -237q0 -152 -71 -245.5t-187 -93.5zM48 10h240q112 0 180 91t68 238q0 145 -74 230t-193 85h-221v-644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0415",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "\u0395",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 482,
    d: "M426 331h-378v-331h-10v664h425v-10h-415v-313h378v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 628,
    d: "M587 0h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98q73 0 126.5 28.5t82 77.5 t41.5 104.5t13 119.5h-240v10h250v-327z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 558,
    d: "M522 0h-10v353h-464v-353h-10v664h10v-301h464v301h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u041D",
    horizAdvX: 558,
    d: "M522 0h-10v353h-464v-353h-10v664h10v-301h464v301h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "\u0397",
    horizAdvX: 558,
    d: "M522 0h-10v353h-464v-353h-10v664h10v-301h464v301h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04CF",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u04C0",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0406",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "\u0399",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 436,
    d: "M389 179v485h10v-485q0 -93 -50.5 -147.5t-145.5 -54.5q-87 0 -135.5 52.5t-48.5 153.5v68h10v-68q0 -96 45.5 -146t128.5 -50q90 0 138 52t48 140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "\u0408",
    horizAdvX: 436,
    d: "M389 179v485h10v-485q0 -93 -50.5 -147.5t-145.5 -54.5q-87 0 -135.5 52.5t-48.5 153.5v68h10v-68q0 -96 45.5 -146t128.5 -50q90 0 138 52t48 140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 542,
    d: "M527 0h-13l-274 381l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u041A",
    horizAdvX: 542,
    d: "M527 0h-13l-274 381l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "\u039A",
    horizAdvX: 542,
    d: "M527 0h-13l-274 381l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 479,
    d: "M459 0h-421v664h10v-654h411v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 655,
    d: "M617 0h-10v653l-271 -653h-14l-274 653v-653h-10v664h17l274 -654l272 654h16v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u041C",
    horizAdvX: 655,
    d: "M617 0h-10v653l-271 -653h-14l-274 653v-653h-10v664h17l274 -654l272 654h16v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "\u039C",
    horizAdvX: 655,
    d: "M617 0h-10v653l-271 -653h-14l-274 653v-653h-10v664h17l274 -654l272 654h16v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "\u039D",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u041E",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "\u039F",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 508,
    d: "M307 255h-259v-255h-10v664h269q83 0 134.5 -59.5t51.5 -148.5t-51 -145t-135 -56zM48 265h259q79 0 127.5 53.5t48.5 137.5t-48.5 141t-127.5 57h-259v-389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u0420",
    horizAdvX: 508,
    d: "M307 255h-259v-255h-10v664h269q83 0 134.5 -59.5t51.5 -148.5t-51 -145t-135 -56zM48 265h259q79 0 127.5 53.5t48.5 137.5t-48.5 141t-127.5 57h-259v-389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "\u03A1",
    horizAdvX: 508,
    d: "M307 255h-259v-255h-10v664h269q83 0 134.5 -59.5t51.5 -148.5t-51 -145t-135 -56zM48 265h259q79 0 127.5 53.5t48.5 137.5t-48.5 141t-127.5 57h-259v-389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 632,
    d: "M605 -14h10q0 -219 -152 -219q-148 0 -150 210q-136 2 -209.5 92.5t-73.5 256.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -168 -72 -256t-208 -90q1 -98 37 -149t103 -51q68 0 105 53t37 156zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93 q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 546,
    d: "M508 0h-10v176q0 68 -37 103t-135 35h-278v-314h-10v664h300q87 0 135.5 -45.5t48.5 -126.5q0 -70 -43.5 -118t-119.5 -55q78 -3 113.5 -38.5t35.5 -104.5v-176zM48 324h278q95 0 140.5 48t45.5 120q0 77 -46 119.5t-128 42.5h-290v-330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "\u0405",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u0422",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "\u03A4",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 560,
    d: "M281 0h-5l-258 664h11l249 -644l253 644h10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 797,
    d: "M607 0h-12l-197 649l-196 -649h-12l-172 664h10l168 -647l197 647h11l197 -647l168 647h10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 570,
    d: "M551 0h-13l-254 330l-252 -330h-13l259 339l-249 325h13l242 -317l242 317h13l-248 -325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u0425",
    horizAdvX: 570,
    d: "M551 0h-13l-254 330l-252 -330h-13l259 339l-249 325h13l242 -317l242 317h13l-248 -325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "\u03A7",
    horizAdvX: 570,
    d: "M551 0h-13l-254 330l-252 -330h-13l259 339l-249 325h13l242 -317l242 317h13l-248 -325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u04AE",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "\u03A5",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 505,
    d: "M486 0h-467v10l454 644h-445v10h458v-10l-455 -644h455v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "\u0396",
    horizAdvX: 505,
    d: "M486 0h-467v10l454 644h-445v10h458v-10l-455 -644h455v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 271,
    d: "M242 -130h-155v849h155v-10h-145v-829h145v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 289,
    d: "M280 0h-11l-259 664h11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 267,
    d: "M180 -130h-155v10h145v829h-145v10h155v-849z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 442,
    d: "M413 473h-15l-176 181l-177 -181h-15l188 191h8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 433,
    d: "M436 -102h-436v10h436v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 329,
    d: "M276 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "\u0430",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 502,
    d: "M51 0h-10v672h10v-353q18 95 78.5 140.5t128.5 45.5q98 0 155 -65.5t57 -191.5t-58 -193.5t-154 -67.5q-69 0 -129 43.5t-78 142.5v-173zM258 -3q92 0 147 64.5t55 186.5q0 121 -54.5 184t-147.5 63q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90q0 -118 58 -183.5 t149 -65.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 461,
    d: "M429 178h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-92 0 -144.5 -60t-52.5 -183q0 -124 52.5 -189.5t141.5 -65.5q75 0 129 49.5t64 131.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "\u0441",
    horizAdvX: 461,
    d: "M429 178h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-92 0 -144.5 -60t-52.5 -183q0 -124 52.5 -189.5t141.5 -65.5q75 0 129 49.5t64 131.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 501,
    d: "M460 0h-10v173q-18 -99 -78 -142.5t-129 -43.5q-96 0 -154 67.5t-58 193.5t57 191.5t155 65.5q68 0 128.5 -45.5t78.5 -140.5v353h10v-672zM243 -3q91 0 149 65.5t58 183.5q0 47 -12.5 90t-36.5 79.5t-65 58t-93 21.5q-93 0 -147.5 -63t-54.5 -184q0 -122 55 -186.5 t147 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "\u0435",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 290,
    d: "M94 0h-10v482h-65v10h65q0 180 188 180v-10q-178 0 -178 -170h181v-10h-181v-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 507,
    d: "M456 -5v184q-10 -49 -33 -86t-53.5 -57.5t-61.5 -30t-62 -9.5q-99 0 -157 64.5t-58 188.5t58.5 190t156.5 66q32 0 62 -9t61 -28.5t54 -57t33 -88.5v170h10v-497q0 -107 -62 -167.5t-158 -60.5q-95 0 -155 56t-60 150h10q1 -90 59.5 -143t145.5 -53q91 0 150.5 57.5 t59.5 160.5zM246 6q102 0 156 73t54 171q0 117 -58.5 181t-151.5 64t-149 -63.5t-56 -182.5q0 -120 55 -181.5t150 -61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 478,
    d: "M437 0h-10v318q0 100 -42.5 138.5t-126.5 38.5q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90v-246h-10v672h10v-353q18 96 77 141t130 45q89 0 134 -40.5t45 -146.5v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "\u04BB",
    horizAdvX: 478,
    d: "M437 0h-10v318q0 100 -42.5 138.5t-126.5 38.5q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90v-246h-10v672h10v-353q18 96 77 141t130 45q89 0 134 -40.5t45 -146.5v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 98,
    d: "M54 0h-10v492h10v-492zM54 551h-10v121h10v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "\u0456",
    horizAdvX: 98,
    d: "M54 0h-10v492h10v-492zM54 551h-10v121h10v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 203,
    d: "M152 -33v525h10v-525q0 -88 -49.5 -144t-124.5 -56q-89 0 -134 54t-45 152h10q3 -94 45 -145t124 -51q71 0 117.5 53t46.5 137zM162 551h-10v121h10v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "\u0458",
    horizAdvX: 203,
    d: "M152 -33v525h10v-525q0 -88 -49.5 -144t-124.5 -56q-89 0 -134 54t-45 152h10q3 -94 45 -145t124 -51q71 0 117.5 53t46.5 137zM162 551h-10v121h10v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 463,
    d: "M445 0h-12l-204 297l-178 -159v-138h-10v672h10v-520l382 340h15l-211 -188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 91,
    d: "M51 0h-10v672h10v-672z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 716,
    d: "M675 0h-10v318q0 101 -34 139t-102 38q-70 0 -116 -52t-46 -125v-318h-10v318q0 100 -34.5 138.5t-102.5 38.5q-83 0 -126 -74t-43 -175v-246h-10v492h10v-173q15 96 63 141t106 45q139 0 143 -153q7 49 35 85t62 52t69 16q73 0 109.5 -40.5t36.5 -146.5v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u043E",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "\u03BF",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 501,
    d: "M51 -233h-10v725h10v-173q18 99 78 142.5t129 43.5q96 0 154 -67.5t58 -193.5t-57 -191.5t-155 -65.5q-68 0 -128.5 45.5t-78.5 140.5v-406zM258 -3q93 0 147.5 63t54.5 184q0 122 -55 186.5t-147 64.5q-91 0 -149 -65.5t-58 -183.5q0 -47 12.5 -90t36.5 -79.5t65 -58 t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "\u0440",
    horizAdvX: 501,
    d: "M51 -233h-10v725h10v-173q18 99 78 142.5t129 43.5q96 0 154 -67.5t58 -193.5t-57 -191.5t-155 -65.5q-68 0 -128.5 45.5t-78.5 140.5v-406zM258 -3q93 0 147.5 63t54.5 184q0 122 -55 186.5t-147 64.5q-91 0 -149 -65.5t-58 -183.5q0 -47 12.5 -90t36.5 -79.5t65 -58 t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 500,
    d: "M742 -14h10q0 -219 -152 -219q-150 0 -150 215v191q-18 -95 -78.5 -140.5t-128.5 -45.5q-98 0 -155 65.5t-57 191.5t58 193.5t154 67.5q69 0 129 -43.5t78 -142.5v173h10v-510q0 -101 36.5 -153t103.5 -52q68 0 105 53t37 156zM243 -3q52 0 93 21.5t65 58t36.5 79.5 t12.5 90q0 118 -58 183.5t-149 65.5q-92 0 -147 -64.5t-55 -186.5q0 -121 54.5 -184t147.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 317,
    d: "M51 0h-10v492h10v-173q19 96 78.5 141t131.5 45h37v-11q-8 1 -37 1q-101 0 -155.5 -74.5t-54.5 -174.5v-246z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "\u0455",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 437,
    d: "M391 184v140h10v-140q0 -84 -45 -140.5t-134 -56.5q-91 0 -136 56t-45 142v440h10v-133h350v-10h-350v-297q0 -82 42.5 -135t128.5 -53q84 0 126.5 53.5t42.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 477,
    d: "M246 0h-10l-218 492h13l210 -477l204 477h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "\u03BD",
    horizAdvX: 477,
    d: "M246 0h-10l-218 492h13l210 -477l204 477h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 669,
    d: "M494 0h-10l-150 473l-150 -473h-10l-156 492h11l150 -477l149 477h12l149 -477l150 477h11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 472,
    d: "M454 0h-13l-205 241l-205 -241h-13l211 248l-207 244h13l201 -236l201 236h13l-208 -244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "\u0445",
    horizAdvX: 472,
    d: "M454 0h-13l-205 241l-205 -241h-13l211 248l-207 244h13l201 -236l201 236h13l-208 -244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "\u0443",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 428,
    d: "M406 0h-382v10l361 472h-346v10h360v-9l-363 -473h370v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 306,
    d: "M276 -131h-19q-48 0 -77 9t-43.5 31t-18.5 47.5t-4 70.5q0 12 2.5 81t2.5 78q0 58 -16 81t-58 23v10q42 0 58 23.5t16 81.5q0 9 -2.5 77t-2.5 80q0 45 4 70.5t18.5 47.5t43.5 31t77 9h19v-10h-19q-45 0 -72 -8t-40.5 -29t-17 -45t-3.5 -66q0 -18 2.5 -77t2.5 -80 q0 -100 -56 -110q56 -11 56 -109q0 -19 -2.5 -78.5t-2.5 -80.5q0 -42 3.5 -66t17 -45t40.5 -29t72 -8h19v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 272,
    d: "M141 -125h-10v861h10v-861z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 302,
    d: "M44 -131h-19v10h19q45 0 72 8t40.5 29t17 45t3.5 66q0 21 -2.5 80.5t-2.5 78.5q0 98 56 109q-56 10 -56 110q0 21 2.5 80t2.5 77q0 42 -3.5 66t-17 45t-40.5 29t-72 8h-19v10h19q48 0 77 -9t43.5 -31t18.5 -47.5t4 -70.5q0 -12 -2.5 -80t-2.5 -77q0 -58 16 -81.5 t58 -23.5v-10q-42 0 -58 -23t-16 -81q0 -9 2.5 -78t2.5 -81q0 -45 -4 -70.5t-18.5 -47.5t-43.5 -31t-77 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 530,
    d: "M490 354v-14q-54 -67 -133 -67q-36 0 -97 35.5t-101 35.5q-69 0 -119 -72v15q53 67 119 67q41 0 102.5 -35.5t95.5 -35.5q78 0 133 71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nbspace",
    unicode: "\xA0",
    horizAdvX: 222
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 141,
    d: "M62 664h17v-71h-17v71zM66 534h9q3 -160 3 -406v-128h-15v128q0 246 3 406z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 461,
    d: "M242 0h-10v69q-92 1 -146 69.5t-54 196.5q0 125 53 188.5t147 65.5v75h10v-75q85 -2 138.5 -52.5t59.5 -136.5h-11q-6 84 -56 130.5t-131 48.5v-500q73 3 125 54.5t62 127.5h10q-10 -79 -64 -134t-133 -58v-69zM232 79v500q-89 -2 -139.5 -63t-50.5 -181q0 -123 51 -189 t139 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 464,
    d: "M427 0h-386v484q0 93 51 147.5t146 54.5q93 0 141 -45.5t48 -158.5v-77h-10v77q0 107 -45.5 150.5t-133.5 43.5q-90 0 -138.5 -52t-48.5 -140v-169h376v-10h-376v-295h376v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 475,
    d: "M438 158l-8 -7l-64 64q-54 -51 -130 -51t-129 51l-64 -64l-7 7l64 64q-52 54 -52 130t51 130l-62 63l7 7l62 -63q55 52 130 52t130 -53l64 64l7 -7l-64 -64q52 -55 52 -129q0 -75 -52 -130zM415 352q0 74 -52.5 126.5t-126.5 52.5q-73 0 -125.5 -52.5t-52.5 -126.5 t52 -126t126 -52t126.5 52.5t52.5 125.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 510,
    d: "M433 108h-174v-108h-10v108h-173v10h173v133h-173v10h173v104l-217 299h13l209 -288l210 288h13l-218 -299v-104h174v-10h-174v-133h174v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 272,
    d: "M141 -125h-10v426h10v-426zM141 736v-382h-10v382h10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 501,
    d: "M40 44h10q2 -81 55.5 -129t145.5 -48q90 0 138 46.5t48 110.5q0 29 -8 50t-18 32.5t-33 20t-37.5 11t-47.5 7t-49 7.5q-111 17 -149.5 43.5t-38.5 90.5q0 102 116 124q-64 14 -88 41.5t-24 78.5q0 66 45.5 106t144.5 40q98 0 141 -48.5t47 -135.5h-9q-6 85 -47 129.5 t-132 44.5q-94 0 -137 -37.5t-43 -98.5q0 -59 35 -82t144 -42q15 -3 47.5 -7t48.5 -7t40.5 -12t36 -21.5t20.5 -35.5t9 -55q0 -90 -79 -128q26 -13 39 -23t24.5 -33.5t11.5 -59.5q0 -68 -50.5 -117.5t-145.5 -49.5q-99 0 -154 51.5t-57 135.5zM356 144q85 35 85 124 q0 32 -8.5 53.5t-21.5 33t-37.5 19t-46.5 10.5t-59.5 8t-65.5 11q-136 -12 -136 -117q0 -60 36 -84t143 -40q103 -16 111 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 322,
    d: "M67 608h-17v71h17v-71zM272 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 696,
    d: "M348 -9q-131 0 -224.5 100.5t-93.5 241.5t93.5 241t224.5 100q132 0 225 -100t93 -241t-93 -241.5t-225 -100.5zM348 1q127 0 217.5 97.5t90.5 234.5t-90.5 234t-217.5 97t-217.5 -97.5t-90.5 -233.5q0 -137 90.5 -234.5t217.5 -97.5zM465 298h10q-5 -44 -39.5 -72.5 t-83.5 -28.5q-59 0 -91 35t-32 96q0 66 32.5 102.5t93.5 36.5q52 0 85 -27t36 -71h-10q-4 43 -34.5 65.5t-76.5 22.5q-56 0 -86 -33.5t-30 -95.5q0 -56 29.5 -88.5t83.5 -32.5q43 0 75 24.5t38 66.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 316,
    d: "M264 298h-9v62q-12 -30 -44.5 -49.5t-72.5 -19.5q-95 0 -95 78q0 40 32.5 59.5t72 21t73 5t34.5 14.5q0 50 -22 74t-74 24q-51 0 -74 -22t-24 -66h-10q2 98 108 98q56 0 80.5 -27t24.5 -81v-171zM255 393v61q-10 -6 -45.5 -8.5t-68.5 -5t-60.5 -20t-27.5 -51.5 q0 -69 85 -69q44 0 78.5 24.5t38.5 68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 382,
    d: "M156 145l-128 172l128 174l7 -9l-123 -164l123 -165zM347 145l-128 172l128 174l7 -9l-123 -164l123 -165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 561,
    d: "M520 0h-10v482h-470v10h480v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 477,
    d: "M318 400h-10v50q0 35 -46 35h-76v-85h-10v192h90q26 0 41 -14t15 -39q0 -19 -11.5 -33t-29.5 -16q37 -1 37 -40v-50zM186 495h76q25 0 37.5 13t12.5 31q0 20 -12.5 31.5t-33.5 11.5h-80v-87zM440 494q0 -79 -56 -135t-136 -56t-135.5 55.5t-55.5 135.5t56 136t135 56 q80 0 136 -56t56 -136zM430 494q0 75 -53.5 128.5t-128.5 53.5t-128 -53.5t-53 -128.5t53 -128t128 -53t128.5 53t53.5 128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 443,
    d: "M393 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 398,
    d: "M198 355q-77 0 -114 44t-37 115t37 114.5t114 43.5t114.5 -43.5t37.5 -114.5t-37.5 -115t-114.5 -44zM198 365q72 0 107 41.5t35 107.5q0 67 -35 107.5t-107 40.5t-106.5 -40.5t-34.5 -107.5q0 -66 34.5 -107.5t106.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 501,
    d: "M255 132h-10v207h-207v10h207v207h10v-207h207v-10h-207v-207zM462 79h-424v10h424v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 252,
    d: "M228 343h-206q0 46 24 80.5t82 69.5q7 4 23 13.5t21.5 12.5t16 10.5t14 12.5t8.5 13.5t6.5 18t1.5 21.5q0 83 -90 83q-93 0 -94 -112h-9q0 60 27.5 90.5t75.5 30.5q45 0 72 -23t27 -69q0 -28 -12.5 -47.5t-27.5 -30t-56 -33.5q-54 -31 -76.5 -61t-24.5 -71h197v-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 259,
    d: "M137 515h-33v9h33q41 0 59.5 23.5t18.5 53.5q0 36 -24.5 56.5t-61.5 20.5q-41 0 -64.5 -27t-23.5 -74h-9q0 50 25.5 80t71.5 30q41 0 68 -23.5t27 -62.5q0 -27 -14.5 -50.5t-42.5 -30.5q31 -6 48.5 -29.5t17.5 -55.5q0 -48 -29.5 -76t-77.5 -28t-73.5 30t-25.5 82h9 q0 -48 23.5 -75.5t66.5 -27.5q44 0 71 25.5t27 69.5q0 35 -22 57.5t-65 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 329,
    d: "M279 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 458,
    d: "M392 -100h-10v776h-190v-776h-10v558q-140 5 -140 114q0 50 37.5 82t111.5 32h240l-39 -10v-776z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 92,
    d: "M55 290h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 117,
    d: "M50 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 127,
    d: "M94 343h-8v267h-64v9h52q12 0 12 12v45h8v-333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 343,
    d: "M171 291q-59 0 -93 39t-34 103q0 65 34.5 104.5t92.5 39.5t91.5 -39t33.5 -105q0 -64 -34 -103t-91 -39zM171 300q53 0 84 36t31 97q0 62 -30.5 98t-84.5 36t-85.5 -36t-31.5 -98q0 -60 31.5 -96.5t85.5 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 382,
    d: "M35 145l-7 8l123 165l-123 164l7 9l128 -174zM226 145l-7 8l123 165l-123 164l7 9l128 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 642,
    d: "M102 343h-8v267h-64v9h52q12 0 12 12v45h8v-333zM83 -20h-12l464 704h12zM583 -10h-9v87h-169v9l167 237h11v-237h33v-9h-33v-87zM574 86v223l-157 -223h157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 627,
    d: "M102 343h-8v267h-64v9h52q12 0 12 12v45h8v-333zM63 -20h-12l464 704h12zM601 -10h-206q0 46 24 80.5t82 69.5q7 4 23 13.5t21.5 12.5t16 10.5t14 12.5t8.5 13.5t6.5 18t1.5 21.5q0 83 -90 83q-93 0 -94 -112h-9q0 60 27.5 90.5t75.5 30.5q45 0 72 -23t27 -69 q0 -28 -12.5 -47.5t-27.5 -30t-56 -33.5q-54 -31 -76.5 -61t-24.5 -71h197v-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 629,
    d: "M140 515h-33v9h33q41 0 59.5 23.5t18.5 53.5q0 36 -24.5 56.5t-61.5 20.5q-41 0 -64.5 -27t-23.5 -74h-9q0 50 25.5 80t71.5 30q41 0 68 -23.5t27 -62.5q0 -27 -14.5 -50.5t-42.5 -30.5q31 -6 48.5 -29.5t17.5 -55.5q0 -48 -29.5 -76t-77.5 -28t-73.5 30t-25.5 82h9 q0 -48 23.5 -75.5t66.5 -27.5q44 0 71 25.5t27 69.5q0 35 -22 57.5t-65 22.5zM100 -20h-12l464 704h12zM570 -10h-9v87h-169v9l167 237h11v-237h33v-9h-33v-87zM561 86v223l-157 -223h157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 471,
    d: "M229 533h10v-24q0 -134 -100 -192q-50 -29 -75.5 -65t-25.5 -93q0 -86 52 -128.5t148 -42.5q87 0 139.5 54t52.5 151h10q0 -99 -54 -157t-148 -58q-100 0 -155 45t-55 136q0 59 26.5 97.5t79.5 69.5q95 55 95 183v24zM226 664h17v-71h-17v71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM383 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM446 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM465 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM451 846l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM208 780h-17v71h17v-71zM413 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM301 726q-93 0 -93 96t93 96q94 0 94 -96t-94 -96zM301 736q84 0 84 86t-84 86q-83 0 -83 -86t83 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 826,
    d: "M811 0h-403v190h-305l-73 -190h-12l257 664h522v-10h-379v-299h354v-10h-354v-335h393v-10zM408 200v454h-126l-175 -454h301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176zM291 -233v10q12 5 12 57 h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM334 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\u0400",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM334 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM397 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM426 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM165 780h-17v71h17v-71zM370 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\u0401",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM165 780h-17v71h17v-71zM370 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM124 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM187 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM206 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM-51 780h-17v71h17v-71zM154 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u0407",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM-51 780h-17v71h17v-71zM154 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\u03AA",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM-51 780h-17v71h17v-71zM154 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 573,
    d: "M286 0h-250v328h-21v10h21v326h231q123 0 200 -88t77 -237q0 -152 -71 -245.5t-187 -93.5zM46 10h240q112 0 180 91t68 238q0 145 -74 230t-193 85h-221v-316h207v-10h-207v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\u0110",
    horizAdvX: 573,
    d: "M286 0h-250v328h-21v10h21v326h231q123 0 200 -88t77 -237q0 -152 -71 -245.5t-187 -93.5zM46 10h240q112 0 180 91t68 238q0 145 -74 230t-193 85h-221v-316h207v-10h-207v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM430 846l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM398 726l-226 165l8 11 l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM461 891l-226 -165l-3 6 l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM479 738l-6 -5l-157 174 l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM465 846l9 -4 q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM222 780h-17v71h17v-71z M427 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 501,
    d: "M403 198l-7 -7l-146 146l-146 -146l-7 7l146 146l-146 146l7 7l146 -146l146 146l7 -7l-146 -146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 633,
    d: "M127 -41l-10 4l32 63q-119 85 -119 300q0 170 75.5 265t212.5 95q86 0 149 -40l36 69l10 -4l-37 -71q127 -89 127 -317q0 -170 -73.5 -258t-211.5 -88q-94 0 -160 43zM472 631l-309 -602q63 -42 155 -42q133 0 204 85.5t71 250.5q0 222 -121 308zM154 35l309 602 q-62 39 -145 39q-133 0 -205.5 -92.5t-72.5 -257.5q0 -206 114 -291z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM360 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM423 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM441 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM184 780h-17v71h17v-71zM389 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293zM428 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 508,
    d: "M321 151h-273v-151h-10v664h10v-117h277q73 0 120.5 -58.5t47.5 -142.5q0 -85 -48 -140t-124 -55zM48 161h273q72 0 117 52t45 133q0 80 -45 135.5t-113 55.5h-277v-376z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 488,
    d: "M214 -9v10q31 -6 55 -6q86 0 136 58.5t50 149.5q0 76 -51 120.5t-145 44.5h-20v10h20q162 0 162 140q0 66 -46 108.5t-136 42.5q-92 0 -140 -46.5t-48 -124.5v-498h-10v498q0 83 50.5 132t147.5 49q95 0 143.5 -45t48.5 -116q0 -131 -129 -145q67 -6 115 -50.5t48 -119.5 q0 -96 -53 -157t-144 -61q-26 0 -54 6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM314 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM377 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM396 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM382 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM139 608h-17v71h17v-71zM344 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM232 554q-93 0 -93 96t93 96q94 0 94 -96t-94 -96zM232 564q84 0 84 86t-84 86q-83 0 -83 -86t83 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 865,
    d: "M819 145h12q-20 -75 -71 -116.5t-123 -41.5q-174 0 -213 178q-10 -79 -72.5 -128.5t-153.5 -49.5q-170 0 -170 140q0 76 48.5 107.5t150.5 40.5q24 2 57.5 3t52.5 2t38.5 4t29 9.5t10.5 17.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173 q95 0 138.5 -42.5t49.5 -130.5q17 84 70.5 128.5t135.5 44.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM415 171v123q-5 -7 -16 -12t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130 q81 0 146 46.5t71 127.5zM425 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 461,
    d: "M429 178h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-92 0 -144.5 -60t-52.5 -183q0 -124 52.5 -189.5t141.5 -65.5q75 0 129 49.5t64 131.5zM232 -233v10q12 5 12 57h-12v61 h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM322 554l-226 165l8 11 l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\u0450",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM322 554l-226 165l8 11 l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM385 719l-226 -165l-3 6 l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM404 566l-6 -5l-157 174 l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM147 608h-17v71h17v-71z M352 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\u0451",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM147 608h-17v71h17v-71z M352 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM171 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM234 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM252 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM-5 608h-17v71h17v-71zM200 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\u0457",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM-5 608h-17v71h17v-71zM200 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 497,
    d: "M435 669l-78 -52q48 -62 75.5 -154.5t27.5 -178.5q0 -82 -18 -142t-48.5 -92.5t-65 -47.5t-73.5 -15q-115 0 -170 69.5t-55 184.5q0 110 54.5 176t155.5 66q66 0 125 -41t82 -101q-7 71 -32.5 144t-67.5 126l-135 -90l-6 8l135 90q-26 32 -59 53h17q27 -17 52 -47l78 52z M450 284v7q-4 71 -68 126.5t-141 55.5q-98 0 -149.5 -63.5t-51.5 -168.5q0 -110 52.5 -177t162.5 -67q37 0 69.5 14.5t62 46t46.5 89.5t17 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM401 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63 q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM338 554l-226 165l8 11 l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM401 719l-226 -165l-3 6 l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM420 566l-6 -5l-157 174 l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM406 674l9 -4 q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM163 608h-17v71h17v-71z M368 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 501,
    d: "M462 339h-424v10h424v-10zM259 490h-17v71h17v-71zM259 120h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 514,
    d: "M120 -57l-8 4l32 68q-55 31 -84.5 91t-29.5 140q0 118 61.5 188.5t166.5 70.5q59 0 107 -25l31 65l8 -4l-31 -65q53 -31 81.5 -90.5t28.5 -139.5q0 -118 -61 -188.5t-164 -70.5q-60 0 -106 23zM148 24l213 447q-48 24 -103 24q-100 0 -159 -68t-59 -181q0 -76 28 -134 t80 -88zM368 466l-212 -446q44 -23 102 -23q99 0 157 68t58 181q0 159 -105 220z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM322 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM385 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM403 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM146 608h-17v71h17v-71zM351 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM389 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 500,
    d: "M51 -233h-10v905h10v-353q18 99 78 142.5t129 43.5q96 0 154 -67.5t58 -193.5t-57 -191.5t-155 -65.5q-68 0 -128.5 45.5t-78.5 140.5v-406zM258 -3q93 0 147.5 63t54.5 184q0 122 -55 186.5t-147 64.5q-91 0 -149 -65.5t-58 -183.5q0 -47 12.5 -90t36.5 -79.5t65 -58 t93 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM151 608h-17v71h17v-71zM356 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM473 818h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM404 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM438 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM369 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    d: "M586 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 47 49 87t132 63l-78 185h-387l-79 -187h-11l282 664h5l281 -664q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27zM491 197l-188 447l-190 -447h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 466,
    d: "M425 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 48 48.5 87.5t135.5 62.5v134q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10 q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27zM415 171v123q-5 -7 -16 -12t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176zM434 891l-226 -165l-3 6 l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 461,
    d: "M429 178h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-92 0 -144.5 -60t-52.5 -183q0 -124 52.5 -189.5t141.5 -65.5q75 0 129 49.5t64 131.5zM375 719l-226 -165l-3 6 l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176zM312 780h-17v71h17v-71z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 461,
    d: "M429 178h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-92 0 -144.5 -60t-52.5 -183q0 -124 52.5 -189.5t141.5 -65.5q75 0 129 49.5t64 131.5zM249 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176zM308 733h-12l-157 180 l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 461,
    d: "M429 178h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-92 0 -144.5 -60t-52.5 -183q0 -124 52.5 -189.5t141.5 -65.5q75 0 129 49.5t64 131.5zM246 561h-12l-157 180l6 5 l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 575,
    d: "M288 0h-250v664h231q123 0 200 -88t77 -237q0 -152 -71 -245.5t-187 -93.5zM48 10h240q112 0 180 91t68 238q0 145 -74 230t-193 85h-221v-644zM263 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 501,
    d: "M460 0h-10v173q-18 -99 -78 -142.5t-129 -43.5q-96 0 -154 67.5t-58 193.5t57 191.5t155 65.5q68 0 128.5 -45.5t78.5 -140.5v353h10v-672zM243 -3q91 0 149 65.5t58 183.5q0 47 -12.5 90t-36.5 79.5t-65 58t-93 21.5q-93 0 -147.5 -63t-54.5 -184q0 -122 55 -186.5 t147 -64.5zM484 552v10q12 5 12 57h-12v71h17v-61q0 -69 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 501,
    d: "M460 0h-10v173q-18 -99 -78 -142.5t-129 -43.5q-96 0 -154 67.5t-58 193.5t57 191.5t155 65.5q68 0 128.5 -45.5t78.5 -140.5v253h-223v10h223v90h10v-90h41v-10h-41v-572zM243 -3q91 0 149 65.5t58 183.5q0 47 -12.5 90t-36.5 79.5t-65 58t-93 21.5q-93 0 -147.5 -63 t-54.5 -184q0 -122 55 -186.5t147 -64.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM424 818h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM412 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM396 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM377 746h10q0 -79 -43 -122.5 t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM271 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM249 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 506,
    d: "M491 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 48 46 86.5t130 61.5h-435v664h439v-10h-429v-299h404v-10h-404v-335h443v-10q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 482,
    d: "M325 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 86 137 136q-6 -1 -16 -1q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5h12q-16 -62 -54 -101t-91 -51q-160 -55 -160 -141 q0 -35 23 -55t66 -20q56 0 95 27zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM259 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM247 561h-12l-157 180l6 5 l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 628,
    d: "M587 0h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98q73 0 126.5 28.5t82 77.5 t41.5 104.5t13 119.5h-240v10h250v-327zM450 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 507,
    d: "M456 -5v184q-10 -49 -33 -86t-53.5 -57.5t-61.5 -30t-62 -9.5q-99 0 -157 64.5t-58 188.5t58.5 190t156.5 66q32 0 62 -9t61 -28.5t54 -57t33 -88.5v170h10v-497q0 -107 -62 -167.5t-158 -60.5q-95 0 -155 56t-60 150h10q1 -90 59.5 -143t145.5 -53q91 0 150.5 57.5 t59.5 160.5zM246 6q102 0 156 73t54 171q0 117 -58.5 181t-151.5 64t-149 -63.5t-56 -182.5q0 -120 55 -181.5t150 -61.5zM379 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 628,
    d: "M587 0h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98q73 0 126.5 28.5t82 77.5 t41.5 104.5t13 119.5h-240v10h250v-327zM332 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 507,
    d: "M456 -5v184q-10 -49 -33 -86t-53.5 -57.5t-61.5 -30t-62 -9.5q-99 0 -157 64.5t-58 188.5t58.5 190t156.5 66q32 0 62 -9t61 -28.5t54 -57t33 -88.5v170h10v-497q0 -107 -62 -167.5t-158 -60.5q-95 0 -155 56t-60 150h10q1 -90 59.5 -143t145.5 -53q91 0 150.5 57.5 t59.5 160.5zM246 6q102 0 156 73t54 171q0 117 -58.5 181t-151.5 64t-149 -63.5t-56 -182.5q0 -120 55 -181.5t150 -61.5zM253 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 628,
    d: "M587 0h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98q73 0 126.5 28.5t82 77.5 t41.5 104.5t13 119.5h-240v10h250v-327zM305 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 507,
    d: "M456 -5v184q-10 -49 -33 -86t-53.5 -57.5t-61.5 -30t-62 -9.5q-99 0 -157 64.5t-58 188.5t58.5 190t156.5 66q32 0 62 -9t61 -28.5t54 -57t33 -88.5v170h10v-497q0 -107 -62 -167.5t-158 -60.5q-95 0 -155 56t-60 150h10q1 -90 59.5 -143t145.5 -53q91 0 150.5 57.5 t59.5 160.5zM246 6q102 0 156 73t54 171q0 117 -58.5 181t-151.5 64t-149 -63.5t-56 -182.5q0 -120 55 -181.5t150 -61.5zM262 712v-10q-12 -5 -12 -57h12v-61h-17v51q0 69 17 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 558,
    d: "M522 0h-10v353h-464v-353h-10v664h10v-146h464v146h10v-664zM48 363h464v145h-464v-145z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 478,
    d: "M293 566h-242v-247q18 96 77 141t130 45q89 0 134 -40.5t45 -146.5v-318h-10v318q0 100 -42.5 138.5t-126.5 38.5q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90v-246h-10v566h-41v10h41v96h10v-96h242v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u045B",
    horizAdvX: 478,
    d: "M293 566h-242v-247q18 96 77 141t130 45q89 0 134 -40.5t45 -146.5v-318h-10v318q0 100 -42.5 138.5t-126.5 38.5q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90v-246h-10v566h-41v10h41v96h10v-96h242v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM192 846l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM238 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM214 818h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM261 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM179 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 178,
    d: "M94 0h-10v492h10v-492zM225 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 85,
    d: "M48 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 48 49 87.5t135 62.5v662h10v-664q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 98,
    d: "M54 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 49 49 89t135 61v490h10v-492q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27zM54 551h-10v121h10v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM51 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 98,
    d: "M54 0h-10v492h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 521,
    d: "M48 0h-10v664h10v-664zM474 179v485h10v-485q0 -93 -50.5 -147.5t-145.5 -54.5q-87 0 -135.5 52.5t-48.5 153.5v68h10v-68q0 -96 45.5 -146t128.5 -50q90 0 138 52t48 140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 192,
    d: "M54 0h-10v492h10v-492zM54 551h-10v121h10v-121zM141 -33v525h10v-525q0 -88 -49.5 -144t-124.5 -56q-89 0 -134 54t-45 152h10q3 -94 45 -145t124 -51q71 0 117.5 53t46.5 137zM151 551h-10v121h10v-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 542,
    d: "M527 0h-13l-274 381l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276zM262 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 463,
    d: "M445 0h-12l-204 297l-178 -159v-138h-10v672h10v-520l382 340h15l-211 -188zM223 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 479,
    d: "M459 0h-421v664h10v-654h411v-10zM204 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 91,
    d: "M51 0h-10v672h10v-672zM190 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 479,
    d: "M459 0h-421v664h10v-654h411v-10zM241 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 91,
    d: "M51 0h-10v672h10v-672zM37 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 479,
    d: "M459 0h-421v664h10v-654h411v-10zM84 553v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 91,
    d: "M51 0h-10v672h10v-672zM74 546v10q12 5 12 57h-12v71h17v-61q0 -69 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 479,
    d: "M459 0h-421v664h10v-377l200 97v-10l-200 -97v-267h411v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 259,
    d: "M135 0h-10v334l-110 -56v10l110 56v328h10v-323l109 57v-10l-109 -57v-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM425 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM386 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM272 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM233 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM287 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM258 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 562,
    d: "M515 -33v33l-467 652v-652h-10v664h14l463 -651v651h10v-697q0 -88 -49.5 -144t-124.5 -56q-19 0 -36 3v10q17 -3 36 -3q71 0 117.5 53t46.5 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 484,
    d: "M433 -33v351q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-351q0 -88 -49.5 -144t-124.5 -56q-14 0 -20 1v10q6 -1 20 -1q71 0 117.5 53t46.5 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM488 818h-343v10h343v-10z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM428 646h-343v10h343v-10z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM452 918h10 q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM393 746h10 q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM337 749l-8 6l139 159l8 -6z M224 749l-8 6l139 159l8 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM278 577l-8 6l139 159l8 -6 zM165 577l-8 6l139 159l8 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 905,
    d: "M890 0h-448q-55 -23 -124 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95q66 0 119 -24v2h439v-10h-422q139 -76 148 -299h249v-10h-248v-22q0 -238 -140 -313h427v-10zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5 t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 925,
    d: "M877 145h12q-20 -75 -71 -116.5t-123 -41.5q-190 0 -218 196q-15 -91 -73 -143.5t-146 -52.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q88 0 145.5 -51t73.5 -140q14 90 69 140.5t142 50.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252 q67 0 114.5 38.5t67.5 109.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM483 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 546,
    d: "M508 0h-10v176q0 68 -37 103t-135 35h-278v-314h-10v664h300q87 0 135.5 -45.5t48.5 -126.5q0 -70 -43.5 -118t-119.5 -55q78 -3 113.5 -38.5t35.5 -104.5v-176zM48 324h278q95 0 140.5 48t45.5 120q0 77 -46 119.5t-128 42.5h-290v-330zM417 891l-226 -165l-3 6l221 170 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 317,
    d: "M51 0h-10v492h10v-173q19 96 78.5 141t131.5 45h37v-11q-8 1 -37 1q-101 0 -155.5 -74.5t-54.5 -174.5v-246zM313 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 546,
    d: "M508 0h-10v176q0 68 -37 103t-135 35h-278v-314h-10v664h300q87 0 135.5 -45.5t48.5 -126.5q0 -70 -43.5 -118t-119.5 -55q78 -3 113.5 -38.5t35.5 -104.5v-176zM48 324h278q95 0 140.5 48t45.5 120q0 77 -46 119.5t-128 42.5h-290v-330zM263 -233v10q12 5 12 57h-12v61 h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 317,
    d: "M51 0h-10v492h10v-173q19 96 78.5 141t131.5 45h37v-11q-8 1 -37 1q-101 0 -155.5 -74.5t-54.5 -174.5v-246zM39 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 546,
    d: "M508 0h-10v176q0 68 -37 103t-135 35h-278v-314h-10v664h300q87 0 135.5 -45.5t48.5 -126.5q0 -70 -43.5 -118t-119.5 -55q78 -3 113.5 -38.5t35.5 -104.5v-176zM48 324h278q95 0 140.5 48t45.5 120q0 77 -46 119.5t-128 42.5h-290v-330zM269 733h-12l-157 180l6 5 l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 317,
    d: "M51 0h-10v492h10v-173q19 96 78.5 141t131.5 45h37v-11q-8 1 -37 1q-101 0 -155.5 -74.5t-54.5 -174.5v-246zM165 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5zM411 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5zM370 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5zM258 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u0218",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5zM258 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5zM227 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u0219",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5zM227 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5zM276 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5zM232 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654zM253 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u021A",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654zM253 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 437,
    d: "M391 184v140h10v-140q0 -84 -45 -140.5t-134 -56.5q-91 0 -136 56t-45 142v440h10v-133h350v-10h-350v-297q0 -82 42.5 -135t128.5 -53q84 0 126.5 53.5t42.5 133.5zM210 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u021B",
    horizAdvX: 437,
    d: "M391 184v140h10v-140q0 -84 -45 -140.5t-134 -56.5q-91 0 -136 56t-45 142v440h10v-133h350v-10h-350v-297q0 -82 42.5 -135t128.5 -53q84 0 126.5 53.5t42.5 133.5zM210 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654zM268 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 454,
    d: "M391 184v140h10v-140q0 -84 -45 -140.5t-134 -56.5q-91 0 -136 56t-45 142v440h10v-133h350v-10h-350v-297q0 -82 42.5 -135t128.5 -53q84 0 126.5 53.5t42.5 133.5zM437 553v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 525,
    d: "M268 0h-10v336h-127v10h127v308h-239v10h486v-10h-237v-308h126v-10h-126v-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 437,
    d: "M400 304h-349v-119q0 -82 42.5 -135t128.5 -53q84 0 126.5 53.5t42.5 133.5v50h10v-50q0 -84 -45 -140.5t-134 -56.5q-91 0 -136 56t-45 142v440h10v-133h350v-10h-350v-168h349v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM427 846l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5 q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM389 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63 q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM450 818h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM412 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM414 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM376 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40 q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM278 726q-93 0 -93 96t93 96q94 0 94 -96t-94 -96zM278 736q84 0 84 86t-84 86q-83 0 -83 -86t83 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM240 554q-93 0 -93 96t93 96q94 0 94 -96t-94 -96zM240 564q84 0 84 86t-84 86q-83 0 -83 -86t83 -86z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM299 749l-8 6l139 159l8 -6zM186 749l-8 6l139 159l8 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM261 577l-8 6l139 159l8 -6zM148 577l-8 6l139 159l8 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 557,
    d: "M396 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 78 116 128q-22 -3 -45 -3q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5v443h10v-443q0 -98 -42.5 -157.5t-123.5 -77.5q-141 -52 -141 -134q0 -35 23 -55 t66 -20q56 0 95 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 481,
    d: "M440 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 49 49.5 89t134.5 61v171q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492q-184 -56 -184 -148q0 -35 23 -55 t66 -20q56 0 95 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 797,
    d: "M607 0h-12l-197 649l-196 -649h-12l-172 664h10l168 -647l197 647h11l197 -647l168 647h10zM561 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 669,
    d: "M494 0h-10l-150 473l-150 -473h-10l-156 492h11l150 -477l149 477h12l149 -477l150 477h11zM497 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293zM447 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM408 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293zM190 780h-17v71h17v-71zM395 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u03AB",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293zM190 780h-17v71h17v-71zM395 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 505,
    d: "M486 0h-467v10l454 644h-445v10h458v-10l-455 -644h455v-10zM397 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 428,
    d: "M406 0h-382v10l361 472h-346v10h360v-9l-363 -473h370v-10zM358 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 505,
    d: "M486 0h-467v10l454 644h-445v10h458v-10l-455 -644h455v-10zM267 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 428,
    d: "M406 0h-382v10l361 472h-346v10h360v-9l-363 -473h370v-10zM227 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 505,
    d: "M486 0h-467v10l454 644h-445v10h458v-10l-455 -644h455v-10zM258 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 428,
    d: "M406 0h-382v10l361 472h-346v10h360v-9l-363 -473h370v-10zM220 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018E",
    unicode: "\u018E",
    horizAdvX: 506,
    d: "M468 0h-453v10h443v335h-404v10h404v299h-429v10h439v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 633,
    d: "M323 -23q-139 0 -213.5 93.5t-79.5 256.5h563q-1 165 -72.5 257t-202.5 92q-109 0 -177.5 -63t-91.5 -178h-10q22 120 93.5 185.5t185.5 65.5q136 0 210.5 -95.5t74.5 -266.5q0 -170 -73 -258.5t-207 -88.5zM322 -13q128 0 199 85.5t72 244.5h-553q7 -156 79.5 -243 t202.5 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u04D8",
    horizAdvX: 633,
    d: "M323 -23q-139 0 -213.5 93.5t-79.5 256.5h563q-1 165 -72.5 257t-202.5 92q-109 0 -177.5 -63t-91.5 -178h-10q22 120 93.5 185.5t185.5 65.5q136 0 210.5 -95.5t74.5 -266.5q0 -170 -73 -258.5t-207 -88.5zM322 -13q128 0 199 85.5t72 244.5h-553q7 -156 79.5 -243 t202.5 -87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 547,
    d: "M236 11l52 402h-119v10h120l9 66q25 183 204 183h8v-10h-8q-170 0 -194 -174l-9 -65h119v-10h-120l-52 -403q-13 -96 -68 -139.5t-136 -43.5h-5v10h5q76 0 129.5 42.5t64.5 131.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0194",
    unicode: "\u0194",
    horizAdvX: 560,
    d: "M279 -233q-50 0 -67.5 22.5t-17.5 73.5q0 42 14 84t66 155l-256 562h11l250 -550l251 550h11l-256 -562q52 -113 66 -155t14 -84q0 -51 -17.5 -73.5t-68.5 -22.5zM279 90q-48 -107 -61.5 -147.5t-13.5 -79.5q0 -45 15.5 -65.5t59.5 -20.5q45 0 60.5 20.5t15.5 65.5 q0 39 -13.5 79.5t-62.5 147.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni019D",
    unicode: "\u019D",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-685q0 -88 -49.5 -144t-124.5 -56q-20 0 -36 3v10q16 -3 36 -3q71 0 117.5 53t46.5 137v697h14l463 -651v651h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 720,
    d: "M684 702h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-35 0 -66 13q39 -84 39 -207q0 -170 -73.5 -258t-211.5 -88t-213 90.5t-75 258.5q0 170 75.5 265t212.5 95q168 0 240 -143q39 -16 72 -16q73 0 73 97q0 48 -19 78zM318 -13q133 0 204 85.5t71 250.5 q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 614,
    d: "M578 543h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-36 0 -64 12q23 -55 23 -124q0 -118 -61 -188.5t-164 -70.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q68 0 119 -32t78 -90q37 -15 69 -15q73 0 73 97q0 48 -19 78zM258 -3q99 0 157 68t58 181 q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 701,
    d: "M509 221v443h10v-115q45 -22 84 -22q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-43 0 -84 23v-319q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 602,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-108q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16 v-374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u01DD",
    horizAdvX: 482,
    d: "M48 347h-12q20 75 71 116.5t123 41.5q222 0 222 -268q0 -115 -57 -182.5t-158 -67.5q-99 0 -153.5 70.5t-54.5 185.5h413q-3 252 -212 252q-67 0 -114.5 -38.5t-67.5 -109.5zM442 233h-403q2 -108 53 -172t145 -64q97 0 151 63.5t54 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01DD",
    unicode: "\u04D9",
    horizAdvX: 482,
    d: "M48 347h-12q20 75 71 116.5t123 41.5q222 0 222 -268q0 -115 -57 -182.5t-158 -67.5q-99 0 -153.5 70.5t-54.5 185.5h413q-3 252 -212 252q-67 0 -114.5 -38.5t-67.5 -109.5zM442 233h-403q2 -108 53 -172t145 -64q97 0 151 63.5t54 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E6",
    unicode: "\u01E6",
    horizAdvX: 628,
    d: "M587 0h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98q73 0 126.5 28.5t82 77.5 t41.5 104.5t13 119.5h-240v10h250v-327zM320 733h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E7",
    unicode: "\u01E7",
    horizAdvX: 507,
    d: "M456 -5v184q-10 -49 -33 -86t-53.5 -57.5t-61.5 -30t-62 -9.5q-99 0 -157 64.5t-58 188.5t58.5 190t156.5 66q32 0 62 -9t61 -28.5t54 -57t33 -88.5v170h10v-497q0 -107 -62 -167.5t-158 -60.5q-95 0 -155 56t-60 150h10q1 -90 59.5 -143t145.5 -53q91 0 150.5 57.5 t59.5 160.5zM246 6q102 0 156 73t54 171q0 117 -58.5 181t-151.5 64t-149 -63.5t-56 -182.5q0 -120 55 -181.5t150 -61.5zM259 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F4",
    unicode: "\u01F4",
    horizAdvX: 628,
    d: "M587 0h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98q73 0 126.5 28.5t82 77.5 t41.5 104.5t13 119.5h-240v10h250v-327zM458 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F5",
    unicode: "\u01F5",
    horizAdvX: 507,
    d: "M456 -5v184q-10 -49 -33 -86t-53.5 -57.5t-61.5 -30t-62 -9.5q-99 0 -157 64.5t-58 188.5t58.5 190t156.5 66q32 0 62 -9t61 -28.5t54 -57t33 -88.5v170h10v-497q0 -107 -62 -167.5t-158 -60.5q-95 0 -155 56t-60 150h10q1 -90 59.5 -143t145.5 -53q91 0 150.5 57.5 t59.5 160.5zM246 6q102 0 156 73t54 171q0 117 -58.5 181t-151.5 64t-149 -63.5t-56 -182.5q0 -120 55 -181.5t150 -61.5zM398 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F8",
    unicode: "\u01F8",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM362 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F9",
    unicode: "\u01F9",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM323 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 203,
    d: "M152 -33v525h10v-525q0 -88 -49.5 -144t-124.5 -56q-89 0 -134 54t-45 152h10q3 -94 45 -145t124 -51q71 0 117.5 53t46.5 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0241",
    unicode: "\u0241",
    horizAdvX: 471,
    d: "M242 0h-10v155q0 134 100 192q50 29 75.5 65t25.5 93q0 86 -52 128.5t-148 42.5q-87 0 -139.5 -54t-52.5 -151h-10q0 99 54 157t148 58q100 0 155 -45t55 -136q0 -59 -26.5 -97.5t-79.5 -69.5q-95 -55 -95 -183v-155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0242",
    unicode: "\u0242",
    horizAdvX: 471,
    d: "M241 0h-10v68q0 36 7 62t23 45t28.5 28.5t35.5 24.5q54 34 74 59t20 68q0 73 -47.5 106.5t-128.5 33.5q-93 0 -142 -43t-49 -124h-10q0 84 50.5 130.5t151.5 46.5q185 0 185 -148q0 -50 -21.5 -76t-77.5 -62q-31 -19 -46 -32t-29 -44t-14 -75v-68z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024C",
    unicode: "\u024C",
    horizAdvX: 643,
    d: "M605 0h-10v176q0 68 -37 103t-135 35h-278v-314h-10v314h-135v10h135v340h300q87 0 135.5 -45.5t48.5 -126.5q0 -70 -43.5 -118t-119.5 -55q78 -3 113.5 -38.5t35.5 -104.5v-176zM145 324h278q95 0 140.5 48t45.5 120q0 77 -46 119.5t-128 42.5h-290v-330z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni024D",
    unicode: "\u024D",
    horizAdvX: 371,
    d: "M343 248h-238v-248h-10v248h-95v10h95v234h10v-173q19 96 78.5 141t131.5 45h37v-11q-8 1 -37 1q-66 0 -114.5 -35.5t-71 -88t-24.5 -113.5h238v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0263",
    unicode: "\u0263",
    horizAdvX: 477,
    d: "M238 -233q-42 0 -57.5 18.5t-15.5 60.5q0 33 12 68t55 126l-214 452h13l206 -441l208 441h13l-215 -453q45 -94 57 -127.5t12 -66.5q0 -41 -16 -59.5t-58 -18.5zM238 27q-40 -85 -51.5 -118t-11.5 -64q0 -37 13 -53.5t50 -16.5q38 0 51 16.5t13 52.5q0 31 -11.5 63.5 t-52.5 119.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0272",
    unicode: "\u0272",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-279q0 -88 -49.5 -144t-124.5 -56q-14 0 -20 1v10q6 -1 20 -1q71 0 117.5 53t46.5 137v525h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 426,
    d: "M376 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 426,
    d: "M219 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 443,
    d: "M393 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 392,
    d: "M332 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 117,
    d: "M67 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 287,
    d: "M143 554q-93 0 -93 96t93 96q94 0 94 -96t-94 -96zM143 564q84 0 84 86t-84 86q-83 0 -83 -86t83 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 294,
    d: "M244 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 48 46 86.5t130 61.5h18q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 416,
    d: "M357 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 360,
    d: "M171 577l-8 6l139 159l8 -6zM58 577l-8 6l139 159l8 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M-159 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M-96 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M-77 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 345,
    d: "M295 559l-5 -5l-117 101l-118 -101l-5 5l115 105h15zM281 731l7 -4q-24 -49 -67 -49q-21 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M-70 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M-104 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M-232 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M-334 608h-17v71h17v-71zM-129 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    horizAdvX: 230,
    d: "M113 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M-241 554q-93 0 -93 96t93 96q94 0 94 -96t-94 -96zM-241 564q84 0 84 86t-84 86q-83 0 -83 -86t83 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M-249 577l-8 6l139 159l8 -6zM-362 577l-8 6l139 159l8 -6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M-234 561h-12l-157 180l6 5l157 -174l157 174l6 -5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0313",
    unicode: "\u0313",
    horizAdvX: 0,
    d: "M-233 712v-10q-12 -5 -12 -57h12v-61h-17v51q0 69 17 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    horizAdvX: 113,
    d: "M-42 374v10q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 117,
    d: "M67 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M-249 -233v10q12 5 12 57h-12v61h17v-51q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M-143 -196v-11q-29 -26 -95 -26q-47 0 -73 22.5t-26 62.5q0 48 46 86.5t130 61.5h18q-184 -56 -184 -148q0 -35 23 -55t66 -20q56 0 95 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032D",
    unicode: "\u032D",
    horizAdvX: 0,
    d: "M-77 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tonos",
    unicode: "\u0384",
    horizAdvX: 78,
    d: "M31 414h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresistonos",
    unicode: "\u0385",
    horizAdvX: 0,
    d: "M-285 608h-17v71h17v-71zM-164 608h-17v71h17v-71zM-239 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Alphatonos",
    unicode: "\u0386",
    horizAdvX: 610,
    d: "M31 414h-8l19 250h13zM592 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM497 197l-188 447l-190 -447h378z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "anoteleia",
    unicode: "\u0387",
    horizAdvX: 92,
    d: "M55 421h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Epsilontonos",
    unicode: "\u0388",
    horizAdvX: 584,
    d: "M31 414h-8l19 250h13zM569 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etatonos",
    unicode: "\u0389",
    horizAdvX: 636,
    d: "M31 414h-8l19 250h13zM600 0h-10v353h-464v-353h-10v664h10v-301h464v301h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iotatonos",
    unicode: "\u038A",
    horizAdvX: 163,
    d: "M31 414h-8l19 250h13zM126 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omicrontonos",
    unicode: "\u038C",
    horizAdvX: 674,
    d: "M31 414h-8l19 250h13zM359 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM359 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Upsilontonos",
    unicode: "\u038E",
    horizAdvX: 628,
    d: "M31 414h-8l19 250h13zM349 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omegatonos",
    unicode: "\u038F",
    horizAdvX: 664,
    d: "M31 414h-8l19 250h13zM626 0h-131v11q54 47 93 149t39 234q0 135 -67 208.5t-203 73.5t-203 -73.5t-67 -208.5t37.5 -234.5t93.5 -147.5v-12h-130v10h120q-50 43 -90.5 142.5t-40.5 241.5q0 139 69.5 215.5t210.5 76.5t210.5 -76.5t69.5 -215.5q0 -140 -40.5 -241 t-90.5 -143h120v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresistonos",
    unicode: "\u0390",
    horizAdvX: 211,
    d: "M55 99v393h10v-394q0 -88 90 -88h17v-10h-17q-100 0 -100 99zM20 608h-17v71h17v-71zM141 608h-17v71h17v-71zM66 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0393",
    horizAdvX: 479,
    d: "M20 664h421v-10h-411v-654h-10v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 479,
    d: "M20 664h421v-10h-411v-654h-10v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u0394",
    d: "M18 0l282 664h5l281 -664h-568zM303 644l-270 -634h537z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Theta",
    unicode: "\u0398",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM134 345v10h364v-10h-364z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lambda",
    unicode: "\u039B",
    horizAdvX: 560,
    d: "M278 664h5l258 -664h-11l-249 644l-253 -644h-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Xi",
    unicode: "\u039E",
    horizAdvX: 506,
    d: "M491 0h-476v10h476v-10zM477 654h-448v10h448v-10zM452 345h-398v10h398v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u03A0",
    horizAdvX: 558,
    d: "M522 0h-10v654h-464v-654h-10v664h484v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 558,
    d: "M522 0h-10v654h-464v-654h-10v664h484v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sigma",
    unicode: "\u03A3",
    horizAdvX: 506,
    d: "M246 333l-227 321v10h458v-10h-445l227 -321l-228 -323h460v-10h-472v10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u03A6",
    horizAdvX: 632,
    d: "M321 0h-10v69q-289 2 -289 258q0 131 74.5 198t214.5 69v70h10v-70q141 -2 215 -69t74 -200t-73 -194t-216 -62v-69zM600 325q0 256 -279 259v-505q139 1 209 59t70 187zM32 327q0 -246 279 -248v505q-136 -2 -207.5 -65.5t-71.5 -191.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 632,
    d: "M321 0h-10v69q-289 2 -289 258q0 131 74.5 198t214.5 69v70h10v-70q141 -2 215 -69t74 -200t-73 -194t-216 -62v-69zM600 325q0 256 -279 259v-505q139 1 209 59t70 187zM32 327q0 -246 279 -248v505q-136 -2 -207.5 -65.5t-71.5 -191.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Psi",
    unicode: "\u03A8",
    horizAdvX: 593,
    d: "M301 0h-10v197q-115 1 -190 62t-75 174v231h10v-231q0 -108 72.5 -166.5t182.5 -59.5v457h10v-457q113 2 184.5 62.5t71.5 171.5v223h10v-223q0 -116 -74 -179t-192 -65v-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u03A9",
    horizAdvX: 614,
    d: "M576 0h-131v11q54 47 93 149t39 234q0 135 -67 208.5t-203 73.5t-203 -73.5t-67 -208.5t37.5 -234.5t93.5 -147.5v-12h-130v10h120q-50 43 -90.5 142.5t-40.5 241.5q0 139 69.5 215.5t210.5 76.5t210.5 -76.5t69.5 -215.5q0 -140 -40.5 -241t-90.5 -143h120v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alphatonos",
    unicode: "\u03AC",
    horizAdvX: 586,
    d: "M450 99v74q-18 -95 -78.5 -140.5t-128.5 -45.5q-98 0 -155 65.5t-57 191.5t58 193.5t154 67.5q69 0 129 -43.5t78 -142.5v173h10v-394q0 -88 90 -88h17v-10h-17q-100 0 -100 99zM243 -3q52 0 93 21.5t65 58t36.5 79.5t12.5 90q0 118 -58 183.5t-149 65.5 q-92 0 -147 -64.5t-55 -186.5q0 -121 54.5 -184t147.5 -63zM265 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilontonos",
    unicode: "\u03AD",
    horizAdvX: 447,
    d: "M270 256h-65q-91 0 -135 -33.5t-44 -88.5q0 -63 54.5 -100t143.5 -37q91 0 141.5 39t50.5 110h10q0 -74 -52 -116.5t-148 -42.5q-95 0 -152.5 40t-57.5 108q0 59 44 91t113 35q-66 1 -104 34.5t-38 83.5q0 59 52.5 92.5t134.5 33.5q92 0 145.5 -42.5t53.5 -112.5h-10 q0 67 -51 106t-139 39q-77 0 -126.5 -30t-49.5 -88q0 -47 38.5 -79t125.5 -32h65v-10zM239 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etatonos",
    unicode: "\u03AE",
    horizAdvX: 484,
    d: "M443 -233h-10v551q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-551zM249 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotatonos",
    unicode: "\u03AF",
    horizAdvX: 177,
    d: "M41 99v393h10v-394q0 -88 90 -88h17v-10h-17q-100 0 -100 99zM49 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresistonos",
    unicode: "\u03B0",
    horizAdvX: 480,
    d: "M240 -13q-100 0 -149.5 42t-49.5 145v318h10v-318q0 -97 47 -137t142 -40t142 40t47 137v318h10v-318q0 -103 -49.5 -145t-149.5 -42zM188 608h-17v71h17v-71zM309 608h-17v71h17v-71zM234 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "alpha",
    unicode: "\u03B1",
    horizAdvX: 586,
    d: "M450 99v74q-18 -95 -78.5 -140.5t-128.5 -45.5q-98 0 -155 65.5t-57 191.5t58 193.5t154 67.5q69 0 129 -43.5t78 -142.5v173h10v-394q0 -88 90 -88h17v-10h-17q-100 0 -100 99zM243 -3q52 0 93 21.5t65 58t36.5 79.5t12.5 90q0 118 -58 183.5t-149 65.5 q-92 0 -147 -64.5t-55 -186.5q0 -121 54.5 -184t147.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "beta",
    unicode: "\u03B2",
    horizAdvX: 488,
    d: "M263 -13q-73 0 -131 33t-81 76v-329h-10v731q0 83 50.5 132t148.5 49q95 0 143 -45.5t48 -119.5q0 -66 -35.5 -100.5t-93.5 -40.5q71 -7 117 -51.5t46 -126.5q0 -87 -53 -147.5t-149 -60.5zM51 498v-387q21 -44 81 -79t132 -35q90 0 140.5 57t50.5 142q0 83 -50.5 127.5 t-145.5 44.5h-20v10h20q162 0 162 135q0 71 -45.5 113.5t-135.5 42.5q-93 0 -141 -46t-48 -125z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u03B3",
    horizAdvX: 477,
    d: "M246 -233h-10v233l-218 492h13l210 -477l204 477h13l-212 -492v-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AF",
    unicode: "\u04AF",
    horizAdvX: 477,
    d: "M246 -233h-10v233l-218 492h13l210 -477l204 477h13l-212 -492v-233z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "delta",
    unicode: "\u03B4",
    horizAdvX: 514,
    d: "M30 246q0 102 48 165.5t133 77.5q-10 2 -14 4q-53 15 -80.5 35t-27.5 57q0 87 174 87q89 0 138 -26l-1 -12q-47 28 -135 28q-166 0 -166 -79q0 -32 25.5 -49.5t74.5 -30.5q12 -3 44.5 -11t49.5 -13t43 -14.5t46 -22t37 -28.5q64 -61 64 -172q0 -114 -61.5 -184.5 t-164.5 -70.5q-105 0 -166 71.5t-61 187.5zM412 407q-22 20 -55.5 36t-57 23t-65.5 17q-91 -7 -142.5 -69.5t-51.5 -167.5q0 -112 58.5 -180.5t158.5 -68.5q99 0 157.5 67.5t58.5 177.5q0 107 -61 165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "epsilon",
    unicode: "\u03B5",
    horizAdvX: 447,
    d: "M270 256h-65q-91 0 -135 -33.5t-44 -88.5q0 -63 54.5 -100t143.5 -37q91 0 141.5 39t50.5 110h10q0 -74 -52 -116.5t-148 -42.5q-95 0 -152.5 40t-57.5 108q0 59 44 91t113 35q-66 1 -104 34.5t-38 83.5q0 59 52.5 92.5t134.5 33.5q92 0 145.5 -42.5t53.5 -112.5h-10 q0 67 -51 106t-139 39q-77 0 -126.5 -30t-49.5 -88q0 -47 38.5 -79t125.5 -32h65v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeta",
    unicode: "\u03B6",
    horizAdvX: 461,
    d: "M399 663l-226 -203q-131 -118 -131 -248q0 -95 53 -148.5t141 -53.5h40q47 0 67 -20t20 -68v-155h-10v154q0 43 -17.5 61t-59.5 18h-40q-93 0 -148.5 56t-55.5 156q0 134 135 256l215 194h-343v10h360v-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eta",
    unicode: "\u03B7",
    horizAdvX: 484,
    d: "M443 -233h-10v551q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-551z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "theta",
    unicode: "\u03B8",
    horizAdvX: 521,
    d: "M259 -23q-225 0 -225 358q0 351 225 351q228 0 228 -349q0 -181 -59.5 -270.5t-168.5 -89.5zM259 -13q102 0 159.5 85.5t58.5 257.5h-433q1 -343 215 -343zM259 676q-214 0 -215 -336h433q-1 336 -218 336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iota",
    unicode: "\u03B9",
    horizAdvX: 177,
    d: "M41 99v393h10v-394q0 -88 90 -88h17v-10h-17q-100 0 -100 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u03BA",
    horizAdvX: 463,
    d: "M445 0h-12l-204 297l-178 -159v-138h-10v492h10v-340l382 340h15l-211 -188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 463,
    d: "M445 0h-12l-204 297l-178 -159v-138h-10v492h10v-340l382 340h15l-211 -188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lambda",
    unicode: "\u03BB",
    horizAdvX: 603,
    d: "M49 672h15q126 0 164 -89l207 -489q36 -84 140 -84h9v-10h-9q-112 0 -149 89l-169 399l-227 -488h-12l234 500l-33 78q-36 84 -155 84h-15v10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\u03BC",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-69 0 -112 23t-59 81v-324h-10v725h10v-329q0 -94 44 -130t127 -36q68 0 117 38t70 92.5t21 118.5v246h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "xi",
    unicode: "\u03BE",
    horizAdvX: 461,
    d: "M286 389v-10h-65q-93 0 -136 -41.5t-43 -123.5q0 -96 53 -150t141 -54h40q47 0 67 -20t20 -68v-155h-10v154q0 43 -17.5 61t-59.5 18h-40q-92 0 -148 56t-56 156q0 165 157 172q-66 1 -104 41.5t-38 98.5q0 66 51 109.5t139 43.5q89 0 142.5 -43.5t53.5 -113.5h-10 q0 67 -51 107t-134 40q-84 0 -132.5 -40.5t-48.5 -105.5q0 -56 38.5 -94t125.5 -38h65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 551,
    d: "M395 99v383h-301v-482h-10v482h-65v10h513v-10h-127v-384q0 -88 90 -88h17v-10h-17q-100 0 -100 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rho",
    unicode: "\u03C1",
    horizAdvX: 501,
    d: "M41 -233v479q0 116 59 187.5t159 71.5q95 0 153 -67.5t58 -193.5q0 -125 -57 -191t-149 -66q-76 0 -135.5 45.5t-77.5 140.5v-406h-10zM51 249q0 -67 21 -122t69.5 -92.5t118.5 -37.5q91 0 145.5 63t54.5 184t-55.5 186t-145.5 65q-95 0 -151.5 -68.5t-56.5 -177.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma1",
    unicode: "\u03C2",
    horizAdvX: 461,
    d: "M276 0h-40q-95 0 -149.5 62.5t-54.5 189.5t55 190t150 63q88 0 143 -51t60 -138h-11q-7 84 -57.5 131.5t-133.5 47.5q-91 0 -143.5 -60.5t-52.5 -182.5t52 -182t142 -60h40q47 0 67 -20t20 -68v-155h-10v154q0 43 -17.5 61t-59.5 18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sigma",
    unicode: "\u03C3",
    horizAdvX: 559,
    d: "M540 482h-211q73 -22 113.5 -85.5t40.5 -156.5q0 -115 -61 -184t-164 -69q-106 0 -167 69.5t-61 183.5t61.5 183t166.5 69h282v-10zM258 -3q98 0 156.5 66.5t58.5 176.5q0 109 -57 175.5t-158 66.5q-100 0 -159 -66t-59 -176q0 -109 58.5 -176t159.5 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tau",
    unicode: "\u03C4",
    horizAdvX: 510,
    d: "M491 482h-236v-384q0 -88 90 -88h17v-10h-17q-100 0 -100 99v383h-226v10h472v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilon",
    unicode: "\u03C5",
    horizAdvX: 480,
    d: "M240 -13q-100 0 -149.5 42t-49.5 145v318h10v-318q0 -97 47 -137t142 -40t142 40t47 137v318h10v-318q0 -103 -49.5 -145t-149.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u03C6",
    horizAdvX: 603,
    d: "M307 -233h-10v220q-125 2 -197 73t-72 186q0 116 72.5 186.5t196.5 72.5v167h10v-167q123 -1 195.5 -71.5t72.5 -187.5t-72.5 -187.5t-195.5 -71.5v-220zM38 246q0 -110 69.5 -178.5t189.5 -70.5v498q-118 -2 -188.5 -70t-70.5 -179zM565 246q0 112 -70 180t-188 69v-498 q118 1 188 69t70 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 603,
    d: "M307 -233h-10v220q-125 2 -197 73t-72 186q0 116 72.5 186.5t196.5 72.5v167h10v-167q123 -1 195.5 -71.5t72.5 -187.5t-72.5 -187.5t-195.5 -71.5v-220zM38 246q0 -110 69.5 -178.5t189.5 -70.5v498q-118 -2 -188.5 -70t-70.5 -179zM565 246q0 112 -70 180t-188 69v-498 q118 1 188 69t70 180z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "chi",
    unicode: "\u03C7",
    horizAdvX: 472,
    d: "M454 -233h-12l-206 357l-206 -357h-12l212 366l-208 359h12l202 -350l202 350h12l-208 -359z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "psi",
    unicode: "\u03C8",
    horizAdvX: 580,
    d: "M285 3v669h10v-669q121 0 177.5 41.5t56.5 129.5v318h10v-318q0 -93 -59 -137t-185 -44v-226h-10v226q-126 0 -185 44t-59 137v318h10v-318q0 -88 56.5 -129.5t177.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omega",
    unicode: "\u03C9",
    horizAdvX: 710,
    d: "M360 330v-84q0 -116 38.5 -182.5t116.5 -66.5q80 0 117.5 66t37.5 171q0 157 -89 258h13q86 -94 86 -258q0 -109 -40.5 -178t-123.5 -69q-80 0 -119.5 61t-41.5 159q-2 -96 -41.5 -158t-120.5 -62q-82 0 -122.5 69t-40.5 178q0 164 86 258h13q-89 -101 -89 -258 q0 -105 37.5 -171t117.5 -66q78 0 116.5 66.5t38.5 182.5v84h10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iotadieresis",
    unicode: "\u03CA",
    horizAdvX: 197,
    d: "M61 99v393h10v-394q0 -88 90 -88h17v-10h-17q-100 0 -100 99zM13 608h-17v71h17v-71zM143 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilondieresis",
    unicode: "\u03CB",
    horizAdvX: 480,
    d: "M240 -13q-100 0 -149.5 42t-49.5 145v318h10v-318q0 -97 47 -137t142 -40t142 40t47 137v318h10v-318q0 -103 -49.5 -145t-149.5 -42zM146 608h-17v71h17v-71zM351 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omicrontonos",
    unicode: "\u03CC",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM259 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "upsilontonos",
    unicode: "\u03CD",
    horizAdvX: 480,
    d: "M240 -13q-100 0 -149.5 42t-49.5 145v318h10v-318q0 -97 47 -137t142 -40t142 40t47 137v318h10v-318q0 -103 -49.5 -145t-149.5 -42zM242 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omegatonos",
    unicode: "\u03CE",
    horizAdvX: 710,
    d: "M360 330v-84q0 -116 38.5 -182.5t116.5 -66.5q80 0 117.5 66t37.5 171q0 157 -89 258h13q86 -94 86 -258q0 -109 -40.5 -178t-123.5 -69q-80 0 -119.5 61t-41.5 159q-2 -96 -41.5 -158t-120.5 -62q-82 0 -122.5 69t-40.5 178q0 164 86 258h13q-89 -101 -89 -258 q0 -105 37.5 -171t117.5 -66q78 0 116.5 66.5t38.5 182.5v84h10zM357 544h-8l19 250h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 762,
    d: "M716 11v174q0 114 -52 154t-153 40q-76 0 -143 -15.5t-103 -42.5v-311h-10v644h-235v10h515v-10h-270v-323q34 26 102 42t146 16q104 0 158.5 -42.5t54.5 -161.5v-174q0 -120 -61 -182t-175 -62q-91 0 -149.5 40t-77.5 115h11q19 -69 74.5 -107t141.5 -38q107 0 166.5 60 t59.5 174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 479,
    d: "M20 664h421v-10h-411v-654h-10v664zM394 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-122 0 -199.5 90.5t-77.5 256.5q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166t-168 64q-118 0 -190 -85.5t-79 -235.5h332v-10h-332v-21q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 1022,
    d: "M562 409h259q84 0 135 -56t51 -145t-51.5 -148.5t-134.5 -59.5h-269v654h-334l-14 -300q-7 -143 -30.5 -222.5t-57 -105.5t-87.5 -26h-9v10h9q52 0 84 26.5t53.5 103.5t28.5 214l15 310h352v-255zM821 399h-259v-389h259q79 0 127.5 57t48.5 141t-48.5 137.5t-127.5 53.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 837,
    d: "M417 409h219q84 0 135 -56t51 -145t-51.5 -148.5t-134.5 -59.5h-229v399h-359v-399h-10v664h10v-255h359v255h10v-255zM636 399h-219v-389h219q79 0 127.5 57t48.5 141t-48.5 137.5t-127.5 53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 762,
    d: "M20 654v10h515v-10h-270v-323q34 26 102 42t147 16q103 0 157.5 -42.5t54.5 -161.5v-185h-10v185q0 114 -52 154t-152 40q-77 0 -144 -15.5t-103 -42.5v-321h-10v654h-235z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 542,
    d: "M527 0h-13l-274 381l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276zM415 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 558,
    d: "M49 0h-12v664h10v-651l461 651h14v-664h-10v652zM360 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 547,
    d: "M509 221q0 -120 -62.5 -182t-179.5 -62q-111 0 -174 55.5t-67 157.5h10q4 -95 65 -149t166 -54q110 0 171 60t61 174v180q-17 -71 -76 -118.5t-160 -47.5q-106 0 -165.5 60t-59.5 184v185h10v-185q0 -119 57 -176.5t158 -57.5q104 0 170 58.5t66 175.5v185h10v-443z M409 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 558,
    d: "M284 -165h-10v165h-236v664h10v-654h464v654h10v-664h-238v-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 508,
    d: "M48 409h259q84 0 135 -56t51 -145t-51.5 -148.5t-134.5 -59.5h-269v664h350v-10h-340v-245zM307 399h-259v-389h259q79 0 127.5 57t48.5 141t-48.5 137.5t-127.5 53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 648,
    d: "M30 -165h-10v175h16q47 0 78.5 28t53 105.5t27.5 210.5l15 310h352v-654h66v-175h-10v165h-588v-165zM552 654h-334l-14 -300q-8 -168 -36.5 -246t-79.5 -98h464v644z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 752,
    d: "M733 0h-15l-337 332v-332h-10v332l-337 -332h-15l343 339l-327 325h15l321 -319v319h10v-319l321 319h15l-327 -325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 530,
    d: "M289 347h-76v10h76q101 0 147.5 49t46.5 111q0 72 -61 115.5t-152 43.5q-101 0 -160.5 -55t-59.5 -148h-10q0 97 60.5 155t168.5 58q97 0 160.5 -46t63.5 -123q0 -65 -44.5 -114t-132.5 -51q95 0 147 -48.5t52 -126.5q0 -91 -69.5 -145.5t-182.5 -54.5q-115 0 -175 57.5 t-60 160.5h10q0 -98 60 -153t167 -55t173.5 52.5t66.5 138.5q0 75 -54.5 122t-161.5 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 558,
    d: "M49 0h-12v664h10v-651l461 651h14v-664h-10v652z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 558,
    d: "M49 0h-12v664h10v-651l461 651h14v-664h-10v652zM415 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 598,
    d: "M562 0h-10v654h-334l-14 -300q-7 -143 -30.5 -222.5t-57 -105.5t-87.5 -26h-9v10h9q52 0 84 26.5t53.5 103.5t28.5 214l15 310h352v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 547,
    d: "M509 221q0 -120 -62.5 -182t-179.5 -62q-111 0 -174 55.5t-67 157.5h10q4 -95 65 -149t166 -54q110 0 171 60t61 174v180q-17 -71 -76 -118.5t-160 -47.5q-106 0 -165.5 60t-59.5 184v185h10v-185q0 -119 57 -176.5t158 -57.5q104 0 170 58.5t66 175.5v185h10v-443z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 608,
    d: "M588 -165h-10v165h-540v664h10v-654h464v654h10v-654h66v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 543,
    d: "M507 0h-10v333q-34 -26 -102 -42t-147 -16q-103 0 -157.5 42.5t-54.5 161.5v185h10v-185q0 -114 52 -154t152 -40q77 0 144 15.5t103 42.5v321h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 716,
    d: "M678 0h-640v664h10v-654h305v654h10v-654h305v654h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 766,
    d: "M746 -165h-10v165h-698v664h10v-654h305v654h10v-654h305v654h10v-654h68v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 727,
    d: "M267 409h259q84 0 135 -56t51 -145t-51.5 -148.5t-134.5 -59.5h-269v654h-237v10h247v-255zM526 399h-259v-389h259q79 0 127.5 57t48.5 141t-48.5 137.5t-127.5 53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 593,
    d: "M307 399h-259v-389h259q79 0 127.5 57t48.5 141t-48.5 137.5t-127.5 53.5zM48 409h259q84 0 135 -56t51 -145t-51.5 -148.5t-134.5 -59.5h-269v664h10v-255zM556 0h-10v664h10v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 508,
    d: "M307 399h-259v-389h259q79 0 127.5 57t48.5 141t-48.5 137.5t-127.5 53.5zM48 409h259q84 0 135 -56t51 -145t-51.5 -148.5t-134.5 -59.5h-269v664h10v-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 579,
    d: "M15 228h10q21 -111 86.5 -176t160.5 -65q118 0 192.5 88.5t74.5 248.5v21h-332v10h332q-7 150 -79 235.5t-190 85.5q-102 0 -168 -64t-77 -166h-10q9 104 77.5 172t177.5 68q129 0 204 -97t75 -265q0 -166 -77.5 -256.5t-199.5 -90.5q-102 0 -170 68t-87 183z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 718,
    d: "M48 0h-10v664h10v-318h67q5 161 79.5 250.5t207.5 89.5q137 0 211.5 -95.5t74.5 -267.5q0 -170 -73.5 -258t-209.5 -88q-141 0 -215.5 92t-74.5 267h-67v-336zM404 -13q133 0 203.5 86t70.5 251q0 167 -71.5 259.5t-203.5 92.5q-133 0 -205.5 -92.5t-72.5 -257.5 q0 -164 72 -251.5t207 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 546,
    d: "M498 314h-226l-240 -314h-13l239 314h-50q-87 0 -135.5 47.5t-48.5 130.5q0 82 48.5 127t135.5 45h300v-664h-10v314zM208 324h290v330h-290q-83 0 -128.5 -42.5t-45.5 -119.5q0 -78 46 -123t128 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 514,
    d: "M257 -13q-105 0 -166 71.5t-61 187.5v90q0 184 65 266q29 38 65.5 50t87.5 12h44q46 0 71.5 9.5t38.5 39.5h11q-12 -35 -42.5 -47t-78.5 -12h-44q-49 0 -83.5 -11t-62.5 -48q-34 -44 -46 -108t-15 -155q20 80 77.5 126.5t140.5 46.5q103 0 163.5 -70t60.5 -188t-61 -189 t-165 -71zM257 -3q100 0 158 68t58 182q0 113 -58 180.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58 -180.5t159 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 483,
    d: "M266 0h-225v492h248q162 0 162 -113q0 -53 -33 -81.5t-83 -31.5q55 -5 93.5 -34.5t38.5 -93.5q0 -138 -201 -138zM51 10h215q191 0 191 128q0 123 -157 123h-249v-251zM51 271h249q141 0 141 106q0 105 -152 105h-238v-211z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 367,
    d: "M54 0h-10v492h304v-10h-294v-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 573,
    d: "M30 -147h-10v157h8q44 0 71 19t45.5 75.5t24.5 157.5l13 230h300v-482h71v-157h-10v147h-513v-147zM472 482h-280l-13 -220q-7 -120 -30.5 -177.5t-63.5 -74.5h387v472z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 633,
    d: "M321 492v-236l265 236h15l-273 -241l287 -251h-15l-279 245v-245h-9v245l-279 -245h-15l287 251l-273 241h15l265 -236v236h9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 447,
    d: "M242 256h-65v10h65q87 0 125.5 32t38.5 79q0 58 -49.5 88t-126.5 30q-88 0 -139 -39t-51 -106h-10q0 70 53.5 112.5t145.5 42.5q82 0 134.5 -33.5t52.5 -92.5q0 -50 -38 -83.5t-104 -34.5q69 -3 113 -35t44 -91q0 -68 -57.5 -108t-152.5 -40q-96 0 -148 42.5t-52 116.5 h10q0 -71 50.5 -110t141.5 -39q89 0 143.5 37t54.5 100q0 55 -44 88.5t-135 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 486,
    d: "M53 0h-12v492h10v-479l380 479h14v-492h-10v480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 486,
    d: "M53 0h-12v492h10v-479l380 479h14v-492h-10v480zM379 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 523,
    d: "M482 0h-10v482h-280l-13 -220q-6 -106 -26.5 -164.5t-49 -78t-75.5 -19.5h-8v10h8q44 0 71 19t45.5 75.5t24.5 157.5l13 230h300v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 581,
    d: "M540 0h-10v481l-231 -481h-14l-234 481v-481h-10v492h17l234 -482l232 482h16v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 486,
    d: "M51 0h-10v492h10v-239h384v239h10v-492h-10v243h-384v-243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 486,
    d: "M51 0h-10v492h404v-492h-10v482h-384v-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 510,
    d: "M260 0h-10v482h-231v10h472v-10h-231v-482z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 536,
    d: "M41 0v492h10v-482h384v482h10v-482h71v-157h-10v147h-465z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 476,
    d: "M435 0h-10v245q-62 -41 -210 -41q-91 0 -137.5 31.5t-46.5 119.5v137h10v-137q0 -85 43 -113t131 -28q148 0 210 40v238h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 694,
    d: "M653 0h-612v492h10v-482h291v482h10v-482h291v482h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 744,
    d: "M724 -147h-10v147h-673v492h10v-482h291v482h10v-482h291v482h10v-482h71v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 750,
    d: "M323 492v-188h273q62 0 100 -42t38 -107q0 -67 -38 -111t-100 -44h-283v482h-294v10h304zM596 294h-273v-284h273q58 0 93 41t35 104q0 62 -34.5 100.5t-93.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 576,
    d: "M41 492h10v-188h273q62 0 100 -42t38 -107q0 -67 -38 -111t-100 -44h-283v492zM324 294h-273v-284h273q58 0 93 41t35 104q0 62 -34.5 100.5t-93.5 38.5zM532 0h-10v492h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 478,
    d: "M41 492h10v-188h273q62 0 100 -42t38 -107q0 -67 -38 -111t-100 -44h-283v492zM324 294h-273v-284h273q58 0 93 41t35 104q0 62 -34.5 100.5t-93.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 461,
    d: "M419 248h-212v10h212q-1 119 -53.5 178t-143.5 59q-81 0 -132 -47t-58 -132h-11q5 87 60 138t141 51q97 0 152 -62.5t55 -190.5q0 -129 -55.5 -197t-148.5 -68q-80 0 -136.5 53t-66.5 138h10q10 -82 64 -131.5t129 -49.5q88 0 140.5 64.5t53.5 186.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 612,
    d: "M54 0h-10v492h10v-232h74q4 112 65.5 178.5t162.5 66.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5q-106 0 -167 72t-61 191h-74v-250zM356 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 474,
    d: "M433 0h-10v216h-227l-165 -216h-13l164 216h-23q-62 0 -100 38t-38 97q0 60 38 100.5t100 40.5h274v-492zM159 226h264v256h-264q-58 0 -93 -37t-35 -94q0 -56 34.5 -90.5t93.5 -34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 478,
    d: "M427 -33v351q0 100 -42.5 138.5t-126.5 38.5q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90v-246h-10v566h-41v10h41v96h10v-96h242v-10h-242v-247q18 96 77 141t130 45q89 0 134 -40.5t45 -146.5v-351q0 -88 -49.5 -144t-124.5 -56q-14 0 -20 1v10q6 -1 20 -1 q71 0 117.5 53t46.5 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 367,
    d: "M54 0h-10v492h304v-10h-294v-482zM338 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 461,
    d: "M254 248h-212q1 -122 53.5 -186.5t140.5 -64.5q75 0 129 49.5t64 131.5h10q-10 -85 -66.5 -138t-136.5 -53q-93 0 -148.5 68t-55.5 197q0 128 55 190.5t152 62.5q86 0 141 -51t60 -138h-11q-7 85 -58 132t-132 47q-91 0 -143.5 -59t-53.5 -178h212v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 909,
    d: "M755 0h-283v482h-280l-13 -220q-6 -106 -26.5 -164.5t-49 -78t-75.5 -19.5h-8v10h8q44 0 71 19t45.5 75.5t24.5 157.5l13 230h300v-188h273q62 0 100 -42t38 -107q0 -67 -38 -111t-100 -44zM755 294h-273v-284h273q58 0 93 41t35 104q0 62 -34.5 100.5t-93.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 792,
    d: "M51 0h-10v492h10v-188h344v188h10v-188h233q62 0 100 -42t38 -107q0 -67 -38 -111t-100 -44h-243v294h-344v-294zM638 294h-233v-284h233q58 0 93 41t35 104q0 62 -34.5 100.5t-93.5 38.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 463,
    d: "M445 0h-12l-204 297l-178 -159v-138h-10v492h10v-340l382 340h15l-211 -188zM376 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 486,
    d: "M53 0h-12v492h10v-479l380 479h14v-492h-10v480zM324 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM381 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 486,
    d: "M41 0v492h10v-482h384v482h10v-492h-197v-147h-10v147h-197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 479,
    d: "M20 664h411v165h10v-175h-411v-654h-10v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 367,
    d: "M348 482h-294v-482h-10v492h294v147h10v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0492",
    unicode: "\u0492",
    horizAdvX: 536,
    d: "M345 318h-258v-318h-10v318h-75v10h75v336h421v-10h-411v-326h258v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0493",
    unicode: "\u0493",
    horizAdvX: 398,
    d: "M85 0h-10v244h-75v10h75v238h304v-10h-294v-228h258v-10h-258v-244z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0496",
    unicode: "\u0496",
    horizAdvX: 802,
    d: "M782 -165h-10v165h-54l-337 332v-332h-10v332l-337 -332h-15l343 339l-327 325h15l321 -319v319h10v-319l321 319h15l-327 -325l333 -329h59v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0497",
    unicode: "\u0497",
    horizAdvX: 683,
    d: "M321 492v-236l265 236h15l-273 -241l275 -241h60v-157h-10v147h-53l-279 245v-245h-9v245l-279 -245h-15l287 251l-273 241h15l265 -236v236h9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0498",
    unicode: "\u0498",
    horizAdvX: 530,
    d: "M289 347h-76v10h76q101 0 147.5 49t46.5 111q0 72 -61 115.5t-152 43.5q-101 0 -160.5 -55t-59.5 -148h-10q0 97 60.5 155t168.5 58q97 0 160.5 -46t63.5 -123q0 -65 -44.5 -114t-132.5 -51q95 0 147 -48.5t52 -126.5q0 -91 -69.5 -145.5t-184.5 -54.5q66 -22 96.5 -52 t30.5 -73q0 -40 -26 -62.5t-73 -22.5q-66 0 -95 26v11q39 -27 95 -27q43 0 66 20t23 55q0 42 -30 70.5t-109 55.5q-103 6 -157 63t-54 154h10q0 -98 60 -153t167 -55t173.5 52.5t66.5 138.5q0 75 -54.5 122t-161.5 47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0499",
    unicode: "\u0499",
    horizAdvX: 447,
    d: "M242 256h-65v10h65q87 0 125.5 32t38.5 79q0 58 -49.5 88t-126.5 30q-88 0 -139 -39t-51 -106h-10q0 70 53.5 112.5t145.5 42.5q82 0 134.5 -33.5t52.5 -92.5q0 -50 -38 -83.5t-104 -34.5q69 -3 113 -35t44 -91q0 -68 -57.5 -108t-152.5 -40q-15 0 -22 1 q137 -50 137 -136q0 -40 -26 -62.5t-73 -22.5q-66 0 -95 26v11q39 -27 95 -27q43 0 66 20t23 55q0 85 -155 139q-73 10 -111.5 50.5t-38.5 104.5h10q0 -71 50.5 -110t141.5 -39q89 0 143.5 37t54.5 100q0 55 -44 88.5t-135 33.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049A",
    unicode: "\u049A",
    horizAdvX: 592,
    d: "M572 -165h-10v165h-48l-274 381l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276l272 -378h52v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni049B",
    unicode: "\u049B",
    horizAdvX: 513,
    d: "M493 -147h-10v147h-50l-204 297l-178 -159v-138h-10v492h10v-340l382 340h15l-211 -188l201 -294h55v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A0",
    unicode: "\u04A0",
    horizAdvX: 761,
    d: "M746 0h-13l-274 381l-192 -194v-187h-10v654h-237v10h247v-464l459 464h15l-274 -276z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A1",
    unicode: "\u04A1",
    horizAdvX: 735,
    d: "M717 0h-12l-204 297l-178 -159v-138h-10v482h-294v10h304v-340l382 340h15l-211 -188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A2",
    unicode: "\u04A2",
    horizAdvX: 608,
    d: "M588 -165h-10v165h-66v353h-464v-353h-10v664h10v-301h464v301h10v-654h66v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04A3",
    unicode: "\u04A3",
    horizAdvX: 536,
    d: "M516 -147h-10v147h-71v243h-384v-243h-10v492h10v-239h384v239h10v-482h71v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AA",
    unicode: "\u04AA",
    horizAdvX: 579,
    d: "M554 228h10q-19 -115 -87 -183t-170 -68q-11 0 -29 2q114 -48 114 -127q0 -40 -26 -62.5t-73 -22.5q-66 0 -95 26v11q39 -27 95 -27q43 0 66 20t23 55q0 80 -134 131q-99 20 -158.5 108t-59.5 233q0 168 75 265t204 97q109 0 177.5 -68t77.5 -172h-10q-11 102 -77 166 t-168 64q-124 0 -196.5 -94t-72.5 -258q0 -160 74.5 -248.5t192.5 -88.5q95 0 160.5 65t86.5 176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04AB",
    unicode: "\u04AB",
    horizAdvX: 461,
    d: "M429 178h10q-10 -86 -67.5 -138.5t-144.5 -52.5q135 -49 135 -137q0 -39 -26.5 -61t-77.5 -22q-62 0 -90 26v11q39 -27 90 -27q94 0 94 74q0 85 -153 139q-78 12 -122.5 79t-44.5 182q0 128 55 191t150 63q88 0 143 -51t60 -138h-11q-7 84 -57.5 131.5t-133.5 47.5 q-91 0 -143.5 -60.5t-52.5 -182.5q0 -123 52.5 -189t140.5 -66q76 0 130 49t64 132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B2",
    unicode: "\u04B2",
    horizAdvX: 620,
    d: "M600 -165h-10v165h-52l-254 330l-252 -330h-13l259 339l-249 325h13l242 -317l242 317h13l-248 -325l252 -329h57v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B3",
    unicode: "\u04B3",
    horizAdvX: 522,
    d: "M502 -147h-10v147h-51l-205 241l-205 -241h-13l211 248l-207 244h13l201 -236l201 236h13l-208 -244l203 -238h57v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B6",
    unicode: "\u04B6",
    horizAdvX: 593,
    d: "M573 -165h-10v165h-66v333q-34 -26 -102 -42t-147 -16q-103 0 -157.5 42.5t-54.5 161.5v185h10v-185q0 -114 52 -154t152 -40q77 0 144 15.5t103 42.5v321h10v-654h66v-175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B7",
    unicode: "\u04B7",
    horizAdvX: 526,
    d: "M506 -147h-10v147h-71v245q-62 -41 -210 -41q-91 0 -137.5 31.5t-46.5 119.5v137h10v-137q0 -85 43 -113t131 -28q148 0 210 40v238h10v-482h71v-157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04BA",
    unicode: "\u04BA",
    horizAdvX: 543,
    d: "M36 664h10v-333q34 26 102 42t147 16q103 0 157.5 -42.5t54.5 -161.5v-185h-10v185q0 114 -52 154t-152 40q-77 0 -144 -15.5t-103 -42.5v-321h-10v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C3",
    unicode: "\u04C3",
    horizAdvX: 542,
    d: "M507 -43q0 -83 -49 -136.5t-132 -53.5q-82 0 -127 55t-45 151h10q2 -91 44.5 -143.5t118.5 -52.5q77 0 123.5 50.5t46.5 127.5q0 44 -15 77.5t-49 80.5l-193 268l-192 -194v-187h-10v664h10v-464l459 464h15l-274 -276l194 -270q35 -48 50 -82.5t15 -78.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C4",
    unicode: "\u04C4",
    horizAdvX: 463,
    d: "M237 304l125 -184q32 -46 46 -82t14 -81q0 -84 -45.5 -137t-122.5 -53q-67 0 -108 44t-49 123h10q8 -74 46.5 -115.5t101.5 -41.5q71 0 114 50.5t43 129.5q0 43 -14 78t-44 79l-125 183l-178 -159v-138h-10v492h10v-340l382 340h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C7",
    unicode: "\u04C7",
    horizAdvX: 558,
    d: "M512 -33v386h-464v-353h-10v664h10v-301h464v301h10v-697q0 -88 -49.5 -144t-124.5 -56q-89 0 -134 54t-45 152h10q3 -94 45 -145t124 -51q71 0 117.5 53t46.5 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04C8",
    unicode: "\u04C8",
    horizAdvX: 486,
    d: "M51 0h-10v492h10v-239h384v239h10v-556q0 -75 -41.5 -122t-105.5 -47q-75 0 -113 45.5t-38 127.5h10q5 -163 141 -163q60 0 98.5 44t38.5 115v307h-384v-243z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E8",
    unicode: "\u04E8",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q134 0 204.5 86.5t70.5 255.5h-553q0 -165 72 -253.5t206 -88.5zM318 676q-130 0 -202.5 -89t-75.5 -248h553q-4 160 -75.5 248.5t-199.5 88.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04E9",
    unicode: "\u04E9",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 495q-99 0 -157.5 -66.5t-60.5 -177.5h433q-2 112 -59.5 178t-155.5 66zM258 -3q97 0 155 66.5t60 177.5h-433q2 -111 60 -177.5t158 -66.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EE",
    unicode: "\u04EE",
    horizAdvX: 547,
    d: "M509 221q0 -120 -62.5 -182t-179.5 -62q-111 0 -174 55.5t-67 157.5h10q4 -95 65 -149t166 -54q110 0 171 60t61 174v180q-17 -71 -76 -118.5t-160 -47.5q-106 0 -165.5 60t-59.5 184v185h10v-185q0 -119 57 -176.5t158 -57.5q104 0 170 58.5t66 175.5v185h10v-443z M445 818h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04EF",
    unicode: "\u04EF",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM416 646h-343v10h343v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0512",
    unicode: "\u0512",
    horizAdvX: 598,
    d: "M552 -33v687h-334l-14 -300q-7 -143 -30.5 -222.5t-57 -105.5t-87.5 -26h-9v10h9q52 0 84 26.5t53.5 103.5t28.5 214l15 310h352v-697q0 -88 -49.5 -144t-124.5 -56q-89 0 -134 54t-45 152h10q3 -94 45 -145t124 -51q71 0 117.5 53t46.5 137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0513",
    unicode: "\u0513",
    horizAdvX: 523,
    d: "M472 -64v546h-280l-13 -220q-6 -106 -26.5 -164.5t-49 -78t-75.5 -19.5h-8v10h8q44 0 71 19t45.5 75.5t24.5 157.5l13 230h300v-556q0 -75 -41.5 -122t-105.5 -47q-75 0 -113 45.5t-38 127.5h10q5 -163 141 -163q60 0 98.5 44t38.5 115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni058F",
    unicode: "\u058F",
    horizAdvX: 475,
    d: "M469 198h-70v-198h-10v198h-263v10h263v130h-263v10h263v137q0 88 -48 140t-138 52q-83 0 -128.5 -50t-45.5 -146v-68h-10v68q0 101 48.5 153.5t135.5 52.5q95 0 145.5 -54.5t50.5 -147.5v-137h70v-10h-70v-130h70v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0C",
    unicode: "\u1E0C",
    horizAdvX: 575,
    d: "M288 0h-250v664h231q123 0 200 -88t77 -237q0 -152 -71 -245.5t-187 -93.5zM48 10h240q112 0 180 91t68 238q0 145 -74 230t-193 85h-221v-644zM266 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E0D",
    unicode: "\u1E0D",
    horizAdvX: 501,
    d: "M460 0h-10v173q-18 -99 -78 -142.5t-129 -43.5q-96 0 -154 67.5t-58 193.5t57 191.5t155 65.5q68 0 128.5 -45.5t78.5 -140.5v353h10v-672zM243 -3q91 0 149 65.5t58 183.5q0 47 -12.5 90t-36.5 79.5t-65 58t-93 21.5q-93 0 -147.5 -63t-54.5 -184q0 -122 55 -186.5 t147 -64.5zM249 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E12",
    unicode: "\u1E12",
    horizAdvX: 575,
    d: "M288 0h-250v664h231q123 0 200 -88t77 -237q0 -152 -71 -245.5t-187 -93.5zM48 10h240q112 0 180 91t68 238q0 145 -74 230t-193 85h-221v-644zM420 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E13",
    unicode: "\u1E13",
    horizAdvX: 501,
    d: "M460 0h-10v173q-18 -99 -78 -142.5t-129 -43.5q-96 0 -154 67.5t-58 193.5t57 191.5t155 65.5q68 0 128.5 -45.5t78.5 -140.5v353h10v-672zM243 -3q91 0 149 65.5t58 183.5q0 47 -12.5 90t-36.5 79.5t-65 58t-93 21.5q-93 0 -147.5 -63t-54.5 -184q0 -122 55 -186.5 t147 -64.5zM403 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E24",
    unicode: "\u1E24",
    horizAdvX: 558,
    d: "M522 0h-10v353h-464v-353h-10v664h10v-301h464v301h10v-664zM287 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E25",
    unicode: "\u1E25",
    horizAdvX: 478,
    d: "M437 0h-10v318q0 100 -42.5 138.5t-126.5 38.5q-52 0 -93 -21.5t-65 -58t-36.5 -79.5t-12.5 -90v-246h-10v672h10v-353q18 96 77 141t130 45q89 0 134 -40.5t45 -146.5v-318zM247 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3C",
    unicode: "\u1E3C",
    horizAdvX: 479,
    d: "M459 0h-421v664h10v-654h411v-10zM412 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E3D",
    unicode: "\u1E3D",
    horizAdvX: 169,
    d: "M93 0h-10v672h10v-672zM250 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E44",
    unicode: "\u1E44",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM289 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E45",
    unicode: "\u1E45",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM250 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4A",
    unicode: "\u1E4A",
    horizAdvX: 562,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM444 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E4B",
    unicode: "\u1E4B",
    horizAdvX: 484,
    d: "M443 0h-10v318q0 100 -43.5 138.5t-128.5 38.5q-101 0 -155.5 -74.5t-54.5 -174.5v-246h-10v492h10v-173q18 96 78.5 141t131.5 45q89 0 135.5 -40.5t46.5 -146.5v-318zM405 -222l-6 -5l-157 174l-157 -174l-6 5l157 180h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5A",
    unicode: "\u1E5A",
    horizAdvX: 546,
    d: "M508 0h-10v176q0 68 -37 103t-135 35h-278v-314h-10v664h300q87 0 135.5 -45.5t48.5 -126.5q0 -70 -43.5 -118t-119.5 -55q78 -3 113.5 -38.5t35.5 -104.5v-176zM48 324h278q95 0 140.5 48t45.5 120q0 77 -46 119.5t-128 42.5h-290v-330zM281 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E5B",
    unicode: "\u1E5B",
    horizAdvX: 317,
    d: "M51 0h-10v492h10v-173q19 96 78.5 141t131.5 45h37v-11q-8 1 -37 1q-101 0 -155.5 -74.5t-54.5 -174.5v-246zM55 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E62",
    unicode: "\u1E62",
    horizAdvX: 534,
    d: "M494 468h-11q-5 98 -64 153t-164 55q-106 0 -158 -43.5t-52 -114.5q0 -57 19 -88.5t57 -50.5q56 -28 155 -36q116 -10 156 -26q78 -33 81 -137v-10q0 -88 -63.5 -140.5t-162.5 -52.5q-258 0 -266 222h10q6 -212 256 -212q94 0 155 49.5t61 133.5q0 41 -10.5 70t-28 45.5 t-43.5 25.5t-54.5 13t-64.5 7q-18 1 -27 2q-63 6 -102.5 15.5t-73 29.5t-49 54t-15.5 86q0 75 54.5 121.5t165.5 46.5q113 0 174 -58.5t65 -159.5zM275 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E63",
    unicode: "\u1E63",
    horizAdvX: 452,
    d: "M418 343h-9q-5 78 -46 115t-133 37q-96 0 -138 -29t-42 -85q0 -57 35.5 -79t143.5 -39q11 -2 36 -4.5t37 -4t33 -6t32 -10t25 -15t21.5 -21.5t12.5 -30t5 -41q0 -63 -49.5 -103.5t-146.5 -40.5q-100 0 -154.5 46t-56.5 125h10q2 -76 55 -118.5t146 -42.5q92 0 139 37.5 t47 96.5q0 24 -4 41t-15 29t-20.5 19.5t-30.5 12.5t-34.5 7.5t-43 6t-45.5 6.5q-112 17 -150 42t-38 86t44.5 92.5t145.5 31.5q99 0 141.5 -40.5t46.5 -121.5zM234 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6C",
    unicode: "\u1E6C",
    horizAdvX: 525,
    d: "M268 0h-10v654h-239v10h486v-10h-237v-654zM271 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E6D",
    unicode: "\u1E6D",
    horizAdvX: 437,
    d: "M391 184v140h10v-140q0 -84 -45 -140.5t-134 -56.5q-91 0 -136 56t-45 142v440h10v-133h350v-10h-350v-297q0 -82 42.5 -135t128.5 -53q84 0 126.5 53.5t42.5 133.5zM227 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 797,
    d: "M607 0h-12l-197 649l-196 -649h-12l-172 664h10l168 -647l197 647h11l197 -647l168 647h10zM480 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 669,
    d: "M494 0h-10l-150 473l-150 -473h-10l-156 492h11l150 -477l149 477h12l149 -477l150 477h11zM416 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 797,
    d: "M607 0h-12l-197 649l-196 -649h-12l-172 664h10l168 -647l197 647h11l197 -647l168 647h10zM543 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 669,
    d: "M494 0h-10l-150 473l-150 -473h-10l-156 492h11l150 -477l149 477h12l149 -477l150 477h11zM479 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 797,
    d: "M607 0h-12l-197 649l-196 -649h-12l-172 664h10l168 -647l197 647h11l197 -647l168 647h10zM304 780h-17v71h17v-71zM509 780h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 669,
    d: "M494 0h-10l-150 473l-150 -473h-10l-156 492h11l150 -477l149 477h12l149 -477l150 477h11zM240 608h-17v71h17v-71zM445 608h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E92",
    unicode: "\u1E92",
    horizAdvX: 505,
    d: "M486 0h-467v10l454 644h-445v10h458v-10l-455 -644h455v-10zM261 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E93",
    unicode: "\u1E93",
    horizAdvX: 428,
    d: "M406 0h-382v10l361 472h-346v10h360v-9l-363 -473h370v-10zM222 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 578,
    d: "M284 664h228v-10l-184 -235h7q96 0 162 -59.5t66 -151.5q0 -94 -66.5 -157.5t-161.5 -63.5q-85 0 -147 51v13q60 -54 147 -54q91 0 154.5 60.5t63.5 149.5q0 88 -62.5 145t-152.5 57q-7 0 -14 -0.5t-10 -0.5v10l185 236h-215q-114 0 -175 -59.5t-61 -174.5v-420h-10v420 q0 120 63.5 182t182.5 62z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM310 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM236 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM310 753h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5 t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM241 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35 t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM603 878l-160 -101l-4 6l157 104zM426 782l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM531 706l-160 -101l-4 6l157 104zM354 610l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM539 777l-160 101l7 9l157 -104zM420 777l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM468 605l-160 101l7 9l157 -104zM349 605l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM419 777l-118 101l-117 -101l-5 5l115 105h15l115 -105zM492 753h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5 t18 -44.5q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM359 605l-118 101l-117 -101l-5 5l115 105h15l115 -105zM432 581h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25 l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM424 731l-5 -5l-117 101l-118 -101l-5 5l115 105h15zM410 903l7 -4q-24 -49 -67 -49q-20 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM363 559l-5 -5l-117 101l-118 -101l-5 5l115 105h15zM349 731l7 -4q-24 -49 -67 -49q-21 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50 q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM465 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12zM310 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM396 566l-6 -5l-157 174l-157 -174l-6 5l157 180h12zM231 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM392 840h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM397 908l-148 -89l-4 6l145 92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM323 668h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM328 736l-148 -89l-4 6l145 92z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM392 840h10q0 -54 -29.5 -84t-71.5 -30q-41 0 -70.5 30t-29.5 84h10q0 -52 26.5 -78t63.5 -26q36 0 63.5 26.5t27.5 77.5zM354 819l-148 89l7 9l145 -92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM323 668h10q0 -54 -29.5 -84t-71.5 -30q-41 0 -70.5 30t-29.5 84h10q0 -52 26.5 -78t63.5 -26q36 0 63.5 26.5t27.5 77.5zM285 647l-148 89l7 9l145 -92z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM392 840h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM299 795h-11l2 10q5 20 28 36t23 32t-10.5 25.5t-28.5 9.5 q-22 0 -44 -19l-3 10q19 19 47 19q22 0 35.5 -12.5t13.5 -32.5q0 -19 -12 -28t-25 -19.5t-15 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM323 668h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM230 623h-11l2 10q5 20 28 36 t23 32t-10.5 25.5t-28.5 9.5q-22 0 -44 -19l-3 10q19 19 47 19q22 0 35.5 -12.5t13.5 -32.5q0 -19 -12 -28t-25 -19.5t-15 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM391 840h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM396 911l8 -4q-17 -47 -57 -47q-19 0 -45.5 22.5t-44.5 22.5 q-31 0 -47 -42l-8 4q17 48 55 48q20 0 46.5 -22.5t43.5 -22.5q34 0 49 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM322 668h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM327 739l8 -4q-17 -47 -57 -47 q-19 0 -45.5 22.5t-44.5 22.5q-31 0 -47 -42l-8 4q17 48 55 48q20 0 46.5 -22.5t43.5 -22.5q34 0 49 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    d: "M586 0h-12l-79 187h-387l-79 -187h-11l282 664h5zM491 197l-188 447l-190 -447h378zM438 918h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5zM310 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 466,
    d: "M425 0h-10v136q-12 -63 -74 -106t-143 -43q-170 0 -170 140q0 77 48 108t151 40q23 2 57 3.5t53 2.5t38.5 4t29 9.5t10.5 16.5q0 92 -41 138t-138 46q-95 0 -138.5 -41.5t-45.5 -121.5h-10q3 173 194 173q102 0 145.5 -48.5t43.5 -145.5v-311zM415 171v123q-5 -7 -16 -12 t-30 -7.5t-37 -3.5t-49.5 -2.5t-54.5 -3.5q-98 -8 -144 -36.5t-46 -101.5q0 -130 160 -130q81 0 146 46.5t71 127.5zM369 746h10q0 -79 -43 -122.5t-103 -43.5t-103 43.5t-43 122.5h10q1 -76 41 -116t95 -40q56 0 95.5 39.5t40.5 116.5zM231 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM268 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM255 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM263 753h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM242 581h-10q1 21 11.5 34.5 t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM405 846l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM390 674l9 -4q-33 -63 -92 -63 q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM557 878l-160 -101l-4 6l157 104zM380 782l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM539 706l-160 -101l-4 6 l157 104zM362 610l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM498 777l-160 101l7 9l157 -104zM379 777l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM480 605l-160 101l7 9 l157 -104zM361 605l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM370 777l-118 101l-117 -101l-5 5l115 105h15l115 -105zM443 753h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5 q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM363 605l-118 101l-117 -101 l-5 5l115 105h15l115 -105zM436 581h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM375 731l-5 -5l-117 101l-118 -101l-5 5l115 105h15zM361 903l7 -4q-24 -49 -67 -49q-21 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM363 559l-5 -5l-117 101 l-118 -101l-5 5l115 105h15zM349 731l7 -4q-24 -49 -67 -49q-21 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 506,
    d: "M491 0h-453v664h439v-10h-429v-299h404v-10h-404v-335h443v-10zM416 738l-6 -5l-157 174l-157 -174l-6 5l157 180h12zM261 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    horizAdvX: 482,
    d: "M434 145h12q-20 -75 -71 -116.5t-123 -41.5q-222 0 -222 268q0 115 57 182.5t158 67.5q99 0 153.5 -70.5t54.5 -185.5h-413q3 -252 212 -252q67 0 114.5 38.5t67.5 109.5zM40 259h403q-2 108 -53 172t-145 64q-97 0 -151 -63.5t-54 -172.5zM404 566l-6 -5l-157 174 l-157 -174l-6 5l157 180h12zM249 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM45 753h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 98,
    d: "M54 0h-10v492h10v-492zM53 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 85,
    d: "M48 0h-10v664h10v-664zM51 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 98,
    d: "M54 0h-10v492h10v-492zM54 551h-10v121h10v-121zM58 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM325 -179h-17v71h17v-71z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM265 -179h-17v71h17v-71z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM314 753h-10q1 21 11.5 34.5 t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM256 581h-10 q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM629 878l-160 -101l-4 6 l157 104zM452 782l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM559 706l-160 -101l-4 6 l157 104zM382 610l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM560 777l-160 101l7 9 l157 -104zM441 777l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM500 605l-160 101l7 9 l157 -104zM381 605l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM428 777l-118 101l-117 -101 l-5 5l115 105h15l115 -105zM501 753h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM372 605l-118 101 l-117 -101l-5 5l115 105h15l115 -105zM445 581h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM439 731l-5 -5l-117 101 l-118 -101l-5 5l115 105h15zM425 903l7 -4q-24 -49 -67 -49q-21 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM379 559l-5 -5l-117 101 l-118 -101l-5 5l115 105h15zM365 731l7 -4q-24 -49 -67 -49q-21 0 -49 23.5t-46 23.5q-39 0 -60 -44l-7 4q24 50 67 50q20 0 48.5 -23.5t46.5 -23.5q37 0 60 43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    horizAdvX: 633,
    d: "M318 -23q-138 0 -213 90.5t-75 258.5q0 170 75.5 265t212.5 95t211 -95.5t74 -267.5q0 -170 -73.5 -258t-211.5 -88zM318 -13q133 0 204 85.5t71 250.5q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM479 738l-6 -5l-157 174 l-157 -174l-6 5l157 180h12zM325 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 514,
    d: "M258 -13q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q104 0 164.5 -70.5t60.5 -188.5t-61 -188.5t-164 -70.5zM258 -3q99 0 157 68t58 181q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM420 566l-6 -5l-157 174 l-157 -174l-6 5l157 180h12zM265 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 720,
    d: "M684 702h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-35 0 -66 13q39 -84 39 -207q0 -170 -73.5 -258t-211.5 -88t-213 90.5t-75 258.5q0 170 75.5 265t212.5 95q168 0 240 -143q39 -16 72 -16q73 0 73 97q0 48 -19 78zM318 -13q133 0 204 85.5t71 250.5 q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM464 891l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 614,
    d: "M578 543h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-36 0 -64 12q23 -55 23 -124q0 -118 -61 -188.5t-164 -70.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q68 0 119 -32t78 -90q37 -15 69 -15q73 0 73 97q0 48 -19 78zM258 -3q99 0 157 68t58 181 q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM401 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 720,
    d: "M684 702h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-35 0 -66 13q39 -84 39 -207q0 -170 -73.5 -258t-211.5 -88t-213 90.5t-75 258.5q0 170 75.5 265t212.5 95q168 0 240 -143q39 -16 72 -16q73 0 73 97q0 48 -19 78zM318 -13q133 0 204 85.5t71 250.5 q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM401 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 614,
    d: "M578 543h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-36 0 -64 12q23 -55 23 -124q0 -118 -61 -188.5t-164 -70.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q68 0 119 -32t78 -90q37 -15 69 -15q73 0 73 97q0 48 -19 78zM258 -3q99 0 157 68t58 181 q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM338 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 720,
    d: "M684 702h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-35 0 -66 13q39 -84 39 -207q0 -170 -73.5 -258t-211.5 -88t-213 90.5t-75 258.5q0 170 75.5 265t212.5 95q168 0 240 -143q39 -16 72 -16q73 0 73 97q0 48 -19 78zM318 -13q133 0 204 85.5t71 250.5 q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM319 753h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5 t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 614,
    d: "M578 543h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-36 0 -64 12q23 -55 23 -124q0 -118 -61 -188.5t-164 -70.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q68 0 119 -32t78 -90q37 -15 69 -15q73 0 73 97q0 48 -19 78zM258 -3q99 0 157 68t58 181 q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM261 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5 t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 720,
    d: "M684 702h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-35 0 -66 13q39 -84 39 -207q0 -170 -73.5 -258t-211.5 -88t-213 90.5t-75 258.5q0 170 75.5 265t212.5 95q168 0 240 -143q39 -16 72 -16q73 0 73 97q0 48 -19 78zM318 -13q133 0 204 85.5t71 250.5 q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM469 846l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 614,
    d: "M578 543h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-36 0 -64 12q23 -55 23 -124q0 -118 -61 -188.5t-164 -70.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q68 0 119 -32t78 -90q37 -15 69 -15q73 0 73 97q0 48 -19 78zM258 -3q99 0 157 68t58 181 q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM406 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 720,
    d: "M684 702h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-35 0 -66 13q39 -84 39 -207q0 -170 -73.5 -258t-211.5 -88t-213 90.5t-75 258.5q0 170 75.5 265t212.5 95q168 0 240 -143q39 -16 72 -16q73 0 73 97q0 48 -19 78zM318 -13q133 0 204 85.5t71 250.5 q0 167 -71.5 260t-203.5 93q-133 0 -205.5 -92.5t-72.5 -257.5q0 -163 72 -251t206 -88zM328 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 614,
    d: "M578 543h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-36 0 -64 12q23 -55 23 -124q0 -118 -61 -188.5t-164 -70.5q-106 0 -167 71.5t-61 187.5q0 118 61.5 188.5t166.5 70.5q68 0 119 -32t78 -90q37 -15 69 -15q73 0 73 97q0 48 -19 78zM258 -3q99 0 157 68t58 181 q0 114 -58 181.5t-157 67.5q-100 0 -159 -68t-59 -181q0 -112 58.5 -180.5t159.5 -68.5zM270 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM287 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM249 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 557,
    d: "M509 221v443h10v-443q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM276 753h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25 q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    horizAdvX: 481,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-492zM248 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10 q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 701,
    d: "M509 221v443h10v-115q45 -22 84 -22q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-43 0 -84 23v-319q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM432 891 l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 602,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-108q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16 v-374zM387 719l-226 -165l-3 6l221 170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 701,
    d: "M509 221v443h10v-115q45 -22 84 -22q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-43 0 -84 23v-319q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM372 726 l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 602,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-108q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16 v-374zM322 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 701,
    d: "M509 221v443h10v-115q45 -22 84 -22q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-43 0 -84 23v-319q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM282 753h-10 q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 602,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-108q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16 v-374zM247 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 701,
    d: "M509 221v443h10v-115q45 -22 84 -22q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-43 0 -84 23v-319q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM439 846l9 -4 q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 602,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-108q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16 v-374zM391 674l9 -4q-33 -63 -92 -63q-27 0 -68 32.5t-64 32.5q-54 0 -83 -57l-9 4q33 63 92 63q27 0 67.5 -32.5t64.5 -32.5q54 0 83 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 701,
    d: "M509 221v443h10v-115q45 -22 84 -22q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-43 0 -84 23v-319q0 -120 -63.5 -182t-182.5 -62q-111 0 -173 59.5t-62 176.5v451h10v-451q0 -112 59.5 -169t165.5 -57q114 0 175 59.5t61 174.5zM289 -179h-17 v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 602,
    d: "M440 0h-10v173q-18 -96 -77.5 -141t-130.5 -45q-89 0 -135 40.5t-46 146.5v318h10v-318q0 -100 43.5 -138.5t127.5 -38.5q68 0 117 38t70 92.5t21 118.5v246h10v-108q36 -16 72 -16q73 0 73 97q0 48 -19 78h10q19 -26 19 -78q0 -55 -22.5 -81t-60.5 -26q-40 0 -72 16 v-374zM239 -179h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293zM365 726l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM326 554l-226 165l8 11l221 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 568,
    d: "M289 0h-10v293l-261 371h13l253 -361l253 361h13l-261 -371v-293zM292 753h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    horizAdvX: 490,
    d: "M439 -5v131q-9 -54 -56.5 -92.5t-144.5 -38.5q-87 0 -137.5 49.5t-50.5 156.5v291h10v-291q0 -102 47.5 -149t130.5 -47q104 0 152.5 47.5t48.5 150.5v289h10v-497q0 -109 -54.5 -168.5t-148.5 -59.5q-93 0 -149 55.5t-56 150.5h10q1 -91 55 -143.5t140 -52.5 q89 0 141 56.5t52 161.5zM253 581h-10q1 21 11.5 34.5t23 19.5t22.5 18.5t10 31.5q0 23 -15 37t-42 14q-30 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -21 -10 -35t-22.5 -20t-23 -18.5t-11.5 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 420,
    d: "M392 304h-364v10h364v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 583,
    d: "M555 304h-527v10h527v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 153,
    d: "M85 731v-10q-12 -5 -12 -57h12v-71h-17v61q0 68 17 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 153,
    d: "M69 553v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 164,
    d: "M75 -67v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 306,
    d: "M85 731v-10q-12 -5 -12 -57h12v-71h-17v61q0 68 17 77zM238 731v-10q-12 -5 -12 -57h12v-71h-17v61q0 68 17 77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 306,
    d: "M69 553v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77zM222 553v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 328,
    d: "M75 -67v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77zM239 -67v10q12 5 12 57h-12v71h17v-61q0 -68 -17 -77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 432,
    d: "M225 0h-10v505h-165v10h165v149h10v-149h157v-10h-157v-505z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 432,
    d: "M382 149h-157v-149h-10v149h-165v10h165v346h-165v10h165v149h10v-149h157v-10h-157v-346h157v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 336,
    d: "M274 343q0 -40 -31 -66.5t-75 -26.5q-46 0 -77 26.5t-31 66.5q0 41 31 67.5t77 26.5q45 0 75.5 -26.5t30.5 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 460,
    d: "M55 0h-17v71h17v-71zM239 0h-17v71h17v-71zM423 0h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 852,
    d: "M133 331q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5t-77.5 -45.5zM133 340q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171zM64 -20h-12l464 704h12zM446 -22q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5 t-77.5 -45.5zM446 -13q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171zM721 -22q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5t-77.5 -45.5zM721 -13q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 191,
    d: "M156 145l-128 172l128 174l7 -9l-123 -164l123 -165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 191,
    d: "M35 145l-7 8l123 165l-123 164l7 9l128 -174z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 108,
    d: "M-172 -20h-12l464 704h12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 265,
    d: "M132 331q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5t-77.5 -45.5zM132 340q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 257,
    d: "M200 343h-9v87h-169v9l167 237h11v-237h33v-9h-33v-87zM191 439v223l-157 -223h157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 265,
    d: "M41 431l2 -2q3 -40 28.5 -64.5t62.5 -24.5q43 0 69.5 30.5t26.5 80.5q0 46 -24 71t-66 25q-32 0 -55.5 -15.5t-41.5 -59.5h-9l7 204h187v-9h-178l-7 -174q31 63 97 63q46 0 72.5 -27.5t26.5 -77.5q0 -54 -29 -87t-76 -33q-41 0 -70 28.5t-31 71.5h8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 263,
    d: "M229 601h-9q-10 77 -80 77q-102 0 -103 -172q18 25 45 40.5t55 15.5q45 0 71 -29.5t26 -81.5t-28 -86t-72 -34q-106 0 -106 168q0 98 27.5 143t84.5 45q37 0 61 -22.5t28 -63.5zM37 490q2 -150 97 -150q41 0 66 31.5t25 79.5t-23.5 75t-64.5 27q-28 0 -55.5 -17.5 t-44.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 258,
    d: "M99 343h-9q6 84 43.5 177t87.5 147h-199v9h212v-7q-52 -52 -91.5 -146.5t-43.5 -179.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 265,
    d: "M131 331q-47 0 -75 28t-28 76q0 32 19 55.5t51 29.5q-28 7 -42.5 30.5t-14.5 50.5q0 40 25 63t65 23q41 0 66.5 -23t25.5 -63q0 -27 -14.5 -50.5t-42.5 -30.5q32 -6 51 -29.5t19 -55.5q0 -48 -28.5 -76t-76.5 -28zM131 340q45 0 70.5 25t25.5 70q0 35 -23.5 57.5 t-72.5 22.5q-48 0 -71 -22.5t-23 -57.5q0 -45 25.5 -70t68.5 -25zM214 601q0 36 -23 56.5t-60 20.5q-36 0 -58.5 -20.5t-22.5 -56.5q0 -31 18 -54t63 -23q46 0 64.5 23t18.5 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 263,
    d: "M33 417h9q10 -77 80 -77q102 0 103 173q-18 -25 -45 -41t-55 -16q-44 0 -70.5 30t-26.5 81q0 52 27.5 86t71.5 34q107 0 107 -167q0 -98 -28 -143.5t-84 -45.5q-37 0 -61 22.5t-28 63.5zM225 529q-2 149 -98 149q-40 0 -65 -31.5t-25 -79.5t23.5 -75t64.5 -27 q28 0 55.5 17.5t44.5 46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 265,
    d: "M132 -22q-103 0 -103 180q0 176 103 176q105 0 105 -175q0 -90 -27.5 -135.5t-77.5 -45.5zM132 -13q96 0 96 172q0 166 -96 166q-94 0 -94 -167q0 -171 94 -171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 127,
    d: "M94 -10h-8v267h-64v9h52q12 0 12 12v45h8v-333z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 252,
    d: "M228 -10h-206q0 46 24 80.5t82 69.5q7 4 23 13.5t21.5 12.5t16 10.5t14 12.5t8.5 13.5t6.5 18t1.5 21.5q0 83 -90 83q-93 0 -94 -112h-9q0 60 27.5 90.5t75.5 30.5q45 0 72 -23t27 -69q0 -28 -12.5 -47.5t-27.5 -30t-56 -33.5q-54 -31 -76.5 -61t-24.5 -71h197v-9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 259,
    d: "M137 162h-33v9h33q41 0 59.5 23.5t18.5 53.5q0 36 -24.5 56.5t-61.5 20.5q-41 0 -64.5 -27t-23.5 -74h-9q0 50 25.5 80t71.5 30q41 0 68 -23.5t27 -62.5q0 -27 -14.5 -50.5t-42.5 -30.5q31 -6 48.5 -29.5t17.5 -55.5q0 -48 -29.5 -76t-77.5 -28t-73.5 30t-25.5 82h9 q0 -48 23.5 -75.5t66.5 -27.5q44 0 71 25.5t27 69.5q0 35 -22 57.5t-65 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 257,
    d: "M200 -10h-9v87h-169v9l167 237h11v-237h33v-9h-33v-87zM191 86v223l-157 -223h157z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 265,
    d: "M41 78l2 -2q3 -40 28.5 -64.5t62.5 -24.5q43 0 69.5 30.5t26.5 80.5q0 46 -24 71t-66 25q-32 0 -55.5 -15.5t-41.5 -59.5h-9l7 204h187v-9h-178l-7 -174q31 63 97 63q46 0 72.5 -27.5t26.5 -77.5q0 -54 -29 -87t-76 -33q-41 0 -70 28.5t-31 71.5h8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 263,
    d: "M229 248h-9q-10 77 -80 77q-102 0 -103 -172q18 25 45 40.5t55 15.5q45 0 71 -29.5t26 -81.5t-28 -86t-72 -34q-106 0 -106 168q0 98 27.5 143t84.5 45q37 0 61 -22.5t28 -63.5zM37 137q2 -150 97 -150q41 0 66 31.5t25 79.5t-23.5 75t-64.5 27q-28 0 -55.5 -17.5 t-44.5 -45.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 258,
    d: "M99 -10h-9q6 84 43.5 177t87.5 147h-199v9h212v-7q-52 -52 -91.5 -146.5t-43.5 -179.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 265,
    d: "M131 -22q-47 0 -75 28t-28 76q0 32 19 55.5t51 29.5q-28 7 -42.5 30.5t-14.5 50.5q0 40 25 63t65 23q41 0 66.5 -23t25.5 -63q0 -27 -14.5 -50.5t-42.5 -30.5q32 -6 51 -29.5t19 -55.5q0 -48 -28.5 -76t-76.5 -28zM131 -13q45 0 70.5 25t25.5 70q0 35 -23.5 57.5 t-72.5 22.5q-48 0 -71 -22.5t-23 -57.5q0 -45 25.5 -70t68.5 -25zM214 248q0 36 -23 56.5t-60 20.5q-36 0 -58.5 -20.5t-22.5 -56.5q0 -31 18 -54t63 -23q46 0 64.5 23t18.5 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 263,
    d: "M33 64h9q10 -77 80 -77q102 0 103 173q-18 -25 -45 -41t-55 -16q-44 0 -70.5 30t-26.5 81q0 52 27.5 86t71.5 34q107 0 107 -167q0 -98 -28 -143.5t-84 -45.5q-37 0 -61 22.5t-28 63.5zM225 176q-2 149 -98 149q-40 0 -65 -31.5t-25 -79.5t23.5 -75t64.5 -27 q28 0 55.5 17.5t44.5 46.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 744,
    d: "M558 0h-11l-73 270h-202l-72 -270h-10l-62 270h-111v10h109l-46 199h-63v10h61l-40 175h9l40 -175h234l48 175h10l47 -175h235l40 175h9l-40 -175h58v-10h-61l-45 -199h106v-10h-109zM429 479l53 -199h131l46 199h-230zM89 479l45 -199h131l54 199h-230zM328 479 l-54 -199h198l-54 199h-90zM485 270l68 -253l58 253h-126zM137 270l58 -253l68 253h-126zM373 649l-43 -160h86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AA",
    unicode: "\u20AA",
    horizAdvX: 576,
    d: "M192 654h-144v-654h-10v664h154q188 0 188 -180v-364h-10v364q0 170 -178 170zM386 10h144v654h10v-664h-154q-188 0 -188 180v364h10v-364q0 -170 178 -170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 564,
    d: "M398 110h-10v134q-15 -79 -63.5 -112t-105.5 -33q-80 0 -127.5 55t-47.5 161q0 103 47 157t128 54q55 0 104.5 -35t64.5 -111v215h-182v10h182v67h10v-67h127v-10h-127v-485zM219 109q74 0 121.5 53.5t47.5 150.5q0 82 -43.5 142t-125.5 60q-75 0 -120 -51.5t-45 -148.5 q0 -100 45 -153t120 -53zM495 0h-448v10h448v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 592,
    d: "M549 106l9 -5q-34 -58 -91 -91t-126 -33q-104 0 -179.5 69t-92.5 195h-45l2 10h42q-3 29 -3 60q0 45 4 80h-45l2 10h44q18 135 89 210t184 75q83 0 155 -50l-4 -9q-69 49 -151 49q-109 0 -177 -72.5t-85 -202.5h303l-5 -10h-300q-4 -33 -4 -80q0 -31 3 -60h233l-5 -10 h-226q17 -121 89 -187.5t172 -66.5q131 0 208 119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 480,
    d: "M455 334h-320l338 -334h-15l-337 332v-332h-10v334h-103v10h103v320h10v-319l321 319h15l-322 -320h320v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AE",
    unicode: "\u20AE",
    horizAdvX: 525,
    d: "M389 454l-121 -59v-150l121 59v-10l-121 -59v-235h-10v230l-122 -59v10l122 59v150l-122 -59v10l122 59v254h-239v10h486v-10h-237v-249l121 59v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 496,
    d: "M491 384h-48q-18 -59 -64.5 -94t-111.5 -35h-194v-255h-10v384h-58v10h58v130h-58v10h58v130h204q63 0 109 -35.5t65 -94.5h50v-10h-47q9 -32 9 -68q0 -32 -8 -62h46v-10zM443 456q0 33 -10 68h-360v-130h362q8 30 8 62zM73 654v-120h357q-18 55 -61 87.5t-102 32.5h-194 zM73 265h194q60 0 103.5 32t61.5 87h-359v-119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    horizAdvX: 628,
    d: "M145 -88h-11l48 100q-72 42 -112 127t-40 194q0 154 77.5 253.5t217.5 99.5q90 0 160 -48l40 81h11l-190 -392h241v-327h-10v208q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-66 0 -123 30zM40 333q0 -106 38.5 -188.5t107.5 -123.5l295 607q-67 48 -156 48 q-135 0 -210 -97t-75 -246zM577 317h-236l-146 -301q56 -29 119 -29q73 0 126.5 28.5t82 77.5t41.5 104.5t13 119.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 534,
    d: "M511 277h-427q-28 -35 -28 -100q0 -91 52.5 -140.5t149.5 -49.5q86 0 143.5 40t70.5 121h10q-14 -83 -73 -127t-151 -44q-101 0 -156.5 52.5t-55.5 147.5q0 63 25 100h-50v10h58q23 28 71 40t94 13.5t98.5 15.5t82.5 44h-404v10h414q30 35 30 99q0 77 -45 122t-137 45 q-167 0 -204 -154h-10q34 164 213 164q97 0 145 -47.5t48 -128.5q0 -62 -28 -100h64v-10h-71q-28 -32 -78 -48t-97 -18t-97 -12.5t-75 -34.5h418v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 510,
    d: "M260 0h-10v482h-231v10h472v-10h-231v-482zM491 654h-472v10h472v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 519,
    d: "M511 487h-115q-1 -77 -48.5 -121t-130.5 -46l165 -320h-10l-167 322v8q86 0 132.5 41t48.5 116h-379v10h379q-2 74 -47.5 115.5t-126.5 41.5h-205v10h504v-10h-227q109 -34 112 -157h115v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 540,
    d: "M95 10h193q88 0 150.5 58.5t85.5 159.5h10q-23 -105 -88.5 -166.5t-157.5 -61.5h-203v218l-77 -37v10l77 37v150l-77 -37v10l77 37v276h10v-271l166 81v-10l-166 -81v-150l166 81v-10l-166 -81v-213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 593,
    d: "M292 664h10v-197q115 -1 190 -62t75 -174v-231h-10v231q0 108 -72.5 166.5t-182.5 59.5v-457h-10v457q-113 -2 -184.5 -62.5t-71.5 -171.5v-223h-10v223q0 116 74 179t192 65v197z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 508,
    d: "M337 135h-239v-135h-10v135h-77v10h77v110h-77v10h77v399h219q83 0 134.5 -59.5t51.5 -148.5t-51 -145t-135 -56h-209v-110h239v-10zM98 265h209q79 0 127.5 53.5t48.5 137.5t-48.5 141t-127.5 57h-209v-389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BE",
    unicode: "\u20BE",
    horizAdvX: 580,
    d: "M389 736v-59q83 -19 123.5 -77.5t50.5 -153.5h-10q-10 92 -48.5 147t-115.5 74v-313h-10v315q-31 7 -73 7q-39 0 -72 -6v-316h-10v314q-187 -39 -187 -261q0 -60 15 -114.5t39.5 -95.5t59 -77t70.5 -61.5t77 -46.5v-12h-260v10h247q-50 23 -93 57t-81.5 82t-61 114.5 t-22.5 143.5q0 231 197 271v58h10v-56q44 6 71 6q35 0 74 -7v57h10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "litre",
    unicode: "\u2113",
    horizAdvX: 300,
    d: "M225 -2v-10q-15 -5 -29 -5q-78 0 -110 106q-41 -18 -84 -21v10q45 4 81 21q-15 57 -15 138q0 55 7 120t22.5 139t47.5 122.5t76 48.5q39 0 53.5 -37t14.5 -102q0 -58 -8.5 -117t-28.5 -122.5t-60.5 -116t-95.5 -79.5q29 -99 102 -99q15 0 27 4zM79 235q0 -76 14 -132 q56 28 95.5 81.5t57.5 118.5t25.5 119.5t7.5 108.5q0 59 -12 92.5t-47 33.5q-41 0 -70.5 -48.5t-44 -121.5t-20.5 -136.5t-6 -115.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 912,
    d: "M525 0h-12l-465 652v-652h-10v664h14l463 -651v651h10v-664zM734 287q-79 0 -125.5 52.5t-46.5 138.5q0 88 47 141t125 53t123 -52.5t45 -141.5q0 -87 -45.5 -139t-122.5 -52zM734 297q72 0 115 49.5t43 131.5q0 83 -43 133.5t-115 50.5q-73 0 -117.5 -50.5t-44.5 -133.5 q0 -80 44 -130.5t118 -50.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2117",
    unicode: "\u2117",
    horizAdvX: 696,
    d: "M348 -9q-131 0 -224.5 100.5t-93.5 241.5t93.5 241t224.5 100q132 0 225 -100t93 -241t-93 -241.5t-225 -100.5zM348 1q127 0 217.5 97.5t90.5 234.5t-90.5 234t-217.5 97t-217.5 -97.5t-90.5 -233.5q0 -137 90.5 -234.5t217.5 -97.5zM380 288h-131v-116h-10v320h141 q46 0 74.5 -30t28.5 -74t-28.5 -72t-74.5 -28zM249 298h131q42 0 67.5 25.5t25.5 64.5q0 40 -26 67t-67 27h-131v-184z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 451,
    d: "M118 407h-10v247h-78v10h166v-10h-78v-247zM414 407h-10v242l-87 -242l-90 242v-241h-10v256h16l84 -232l82 232h15v-257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 632,
    d: "M102 343h-8v267h-64v9h52q12 0 12 12v45h8v-333zM63 -20h-12l464 704h12zM510 162h-33v9h33q41 0 59.5 23.5t18.5 53.5q0 36 -24.5 56.5t-61.5 20.5q-41 0 -64.5 -27t-23.5 -74h-9q0 50 25.5 80t71.5 30q41 0 68 -23.5t27 -62.5q0 -27 -14.5 -50.5t-42.5 -30.5 q31 -6 48.5 -29.5t17.5 -55.5q0 -48 -29.5 -76t-77.5 -28t-73.5 30t-25.5 82h9q0 -48 23.5 -75.5t66.5 -27.5q44 0 71 25.5t27 69.5q0 35 -22 57.5t-65 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 627,
    d: "M236 343h-206q0 46 24 80.5t82 69.5q7 4 23 13.5t21.5 12.5t16 10.5t14 12.5t8.5 13.5t6.5 18t1.5 21.5q0 83 -90 83q-93 0 -94 -112h-9q0 60 27.5 90.5t75.5 30.5q45 0 72 -23t27 -69q0 -28 -12.5 -47.5t-27.5 -30t-56 -33.5q-54 -31 -76.5 -61t-24.5 -71h197v-9z M88 -20h-12l464 704h12zM505 162h-33v9h33q41 0 59.5 23.5t18.5 53.5q0 36 -24.5 56.5t-61.5 20.5q-41 0 -64.5 -27t-23.5 -74h-9q0 50 25.5 80t71.5 30q41 0 68 -23.5t27 -62.5q0 -27 -14.5 -50.5t-42.5 -30.5q31 -6 48.5 -29.5t17.5 -55.5q0 -48 -29.5 -76t-77.5 -28 t-73.5 30t-25.5 82h9q0 -48 23.5 -75.5t66.5 -27.5q44 0 71 25.5t27 69.5q0 35 -22 57.5t-65 22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 635,
    d: "M102 343h-8v267h-64v9h52q12 0 12 12v45h8v-333zM53 -20h-12l464 704h12zM504 -22q-47 0 -75 28t-28 76q0 32 19 55.5t51 29.5q-28 7 -42.5 30.5t-14.5 50.5q0 40 25 63t65 23q41 0 66.5 -23t25.5 -63q0 -27 -14.5 -50.5t-42.5 -30.5q32 -6 51 -29.5t19 -55.5 q0 -48 -28.5 -76t-76.5 -28zM504 -13q45 0 70.5 25t25.5 70q0 35 -23.5 57.5t-72.5 22.5q-48 0 -71 -22.5t-23 -57.5q0 -45 25.5 -70t68.5 -25zM587 248q0 36 -23 56.5t-60 20.5q-36 0 -58.5 -20.5t-22.5 -56.5q0 -31 18 -54t63 -23q46 0 64.5 23t18.5 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 632,
    d: "M140 515h-33v9h33q41 0 59.5 23.5t18.5 53.5q0 36 -24.5 56.5t-61.5 20.5q-41 0 -64.5 -27t-23.5 -74h-9q0 50 25.5 80t71.5 30q41 0 68 -23.5t27 -62.5q0 -27 -14.5 -50.5t-42.5 -30.5q31 -6 48.5 -29.5t17.5 -55.5q0 -48 -29.5 -76t-77.5 -28t-73.5 30t-25.5 82h9 q0 -48 23.5 -75.5t66.5 -27.5q44 0 71 25.5t27 69.5q0 35 -22 57.5t-65 22.5zM90 -20h-12l464 704h12zM501 -22q-47 0 -75 28t-28 76q0 32 19 55.5t51 29.5q-28 7 -42.5 30.5t-14.5 50.5q0 40 25 63t65 23q41 0 66.5 -23t25.5 -63q0 -27 -14.5 -50.5t-42.5 -30.5 q32 -6 51 -29.5t19 -55.5q0 -48 -28.5 -76t-76.5 -28zM501 -13q45 0 70.5 25t25.5 70q0 35 -23.5 57.5t-72.5 22.5q-48 0 -71 -22.5t-23 -57.5q0 -45 25.5 -70t68.5 -25zM584 248q0 36 -23 56.5t-60 20.5q-36 0 -58.5 -20.5t-22.5 -56.5q0 -31 18 -54t63 -23q46 0 64.5 23 t18.5 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 612,
    d: "M38 431l2 -2q3 -40 28.5 -64.5t62.5 -24.5q43 0 69.5 30.5t26.5 80.5q0 46 -24 71t-66 25q-32 0 -55.5 -15.5t-41.5 -59.5h-9l7 204h187v-9h-178l-7 -174q32 63 97 63q46 0 72.5 -27.5t26.5 -77.5q0 -54 -29 -87t-76 -33q-41 0 -70 28.5t-31 71.5h8zM80 -20h-12l464 704 h12zM481 -22q-47 0 -75 28t-28 76q0 32 19 55.5t51 29.5q-28 7 -42.5 30.5t-14.5 50.5q0 40 25 63t65 23q41 0 66.5 -23t25.5 -63q0 -27 -14.5 -50.5t-42.5 -30.5q32 -6 51 -29.5t19 -55.5q0 -48 -28.5 -76t-76.5 -28zM481 -13q45 0 70.5 25t25.5 70q0 35 -23.5 57.5 t-72.5 22.5q-48 0 -71 -22.5t-23 -57.5q0 -45 25.5 -70t68.5 -25zM564 248q0 36 -23 56.5t-60 20.5q-36 0 -58.5 -20.5t-22.5 -56.5q0 -31 18 -54t63 -23q46 0 64.5 23t18.5 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 656,
    d: "M107 343h-9q6 84 43.5 177t87.5 147h-199v9h212v-7q-52 -52 -91.5 -146.5t-43.5 -179.5zM94 -20h-12l464 704h12zM525 -22q-47 0 -75 28t-28 76q0 32 19 55.5t51 29.5q-28 7 -42.5 30.5t-14.5 50.5q0 40 25 63t65 23q41 0 66.5 -23t25.5 -63q0 -27 -14.5 -50.5 t-42.5 -30.5q32 -6 51 -29.5t19 -55.5q0 -48 -28.5 -76t-76.5 -28zM525 -13q45 0 70.5 25t25.5 70q0 35 -23.5 57.5t-72.5 22.5q-48 0 -71 -22.5t-23 -57.5q0 -45 25.5 -70t68.5 -25zM608 248q0 36 -23 56.5t-60 20.5q-36 0 -58.5 -20.5t-22.5 -56.5q0 -31 18 -54t63 -23 q46 0 64.5 23t18.5 54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 545,
    d: "M71 627l-3 9q52 50 179 50q57 0 101 -17t81 -57t57 -116t20 -185q0 -334 -250 -334q-102 0 -159.5 65.5t-57.5 174.5q0 107 56.5 165t157.5 58q155 0 243 -129q0 106 -19 180t-54.5 113t-78 55.5t-97.5 16.5q-120 0 -176 -49zM496 294q-87 136 -243 136q-96 0 -150 -55 t-54 -158q0 -105 55 -167.5t152 -62.5q233 0 240 307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 572,
    d: "M513 -233h-9v887h-436v-887h-10v897h455v-897z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 505,
    d: "M461 -182h-417v10l217 413l-217 413v10h417v-10h-405l217 -413l-218 -413h406v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 501,
    d: "M462 339h-424v10h424v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 555,
    d: "M275 0h-9l-129 356h-104v10h114l123 -349l240 647h11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 635,
    d: "M318 322q-18 -80 -49.5 -113.5t-85.5 -33.5q-56 0 -92.5 43t-36.5 122t36.5 122t92.5 43q54 0 85.5 -33.5t49.5 -113.5q16 80 46.5 113.5t88.5 33.5q56 0 92 -43t36 -122t-36 -122t-92 -43q-58 0 -88.5 33.5t-46.5 113.5zM322 340q16 -87 46 -121t85 -34q51 0 84.5 40.5 t33.5 114.5t-33.5 114.5t-84.5 40.5q-55 0 -85 -34t-46 -121zM315 340q-19 83 -50.5 119t-81.5 36q-52 0 -85.5 -40.5t-33.5 -114.5t33.5 -114.5t85.5 -40.5q50 0 81.5 36t50.5 119z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 508,
    d: "M79 -233h-21v10h21q77 0 123.5 40.5t46.5 132.5v539q0 96 49.5 139.5t130.5 43.5h21v-10h-21q-77 0 -123.5 -40.5t-46.5 -132.5v-539q0 -96 -49.5 -139.5t-130.5 -43.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 530,
    d: "M490 244v-14q-54 -67 -133 -67q-36 0 -97 35.5t-101 35.5q-69 0 -119 -72v15q53 67 119 67q41 0 102.5 -35.5t95.5 -35.5q78 0 133 71zM490 464v-14q-54 -67 -133 -67q-36 0 -97 35.5t-101 35.5q-69 0 -119 -72v15q53 67 119 67q41 0 102.5 -35.5t95.5 -35.5q78 0 133 71 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 501,
    d: "M25 -20h-13l169 257h-143v10h149l127 193h-276v10h283l154 234h13l-154 -234h128v-10h-135l-127 -193h262v-10h-268z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 501,
    d: "M462 96l-424 242v10l424 242v-12l-414 -235l414 -235v-12zM462 69h-424v10h424v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 501,
    d: "M462 338l-424 -242v12l414 235l-414 235v12l424 -242v-10zM462 69h-424v10h424v-10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotmath",
    unicode: "\u22C5",
    horizAdvX: 92,
    d: "M55 290h-17v71h17v-71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 533,
    d: "M274 0h-7l-213 332l213 332h7l204 -332zM270 13l196 319l-195 320l-206 -320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE000",
    unicode: "\uE000",
    horizAdvX: 628,
    d: "M869 -14h10q0 -219 -152 -219q-150 0 -150 215v226q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98 q73 0 126.5 28.5t82 77.5t41.5 104.5t13 119.5h-240v10h250v-345q0 -101 36.5 -153t103.5 -52q68 0 105 53t37 156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE001",
    unicode: "\uE001",
    horizAdvX: 501,
    d: "M460 -233h-10v406q-18 -95 -78.5 -140.5t-128.5 -45.5q-98 0 -155 65.5t-57 191.5t58 193.5t154 67.5q69 0 129 -43.5t78 -142.5v173h10v-725zM243 -3q52 0 93 21.5t65 58t36.5 79.5t12.5 90q0 118 -58 183.5t-149 65.5q-92 0 -147 -64.5t-55 -186.5q0 -121 54.5 -184 t147.5 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE002",
    unicode: "\uE002",
    horizAdvX: 447,
    d: "M239 113l-202 228l202 227l7 -8l-191 -214h354v-10h-354l191 -215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE003",
    unicode: "\uE003",
    horizAdvX: 448,
    d: "M208 113l-7 8l191 215h-354v10h354l-191 214l7 8l202 -227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE004",
    unicode: "\uE004",
    horizAdvX: 1001,
    d: "M869 -14h10q0 -219 -152 -219q-150 0 -150 215v226q-10 -46 -28 -84.5t-48 -73t-78 -54t-109 -19.5q-129 0 -206.5 101t-77.5 255t77.5 253.5t217.5 99.5q107 0 180.5 -64t80.5 -163h-10q-8 97 -79.5 157t-171.5 60q-135 0 -210 -97t-75 -246q0 -150 74.5 -248t199.5 -98 q73 0 126.5 28.5t82 77.5t41.5 104.5t13 119.5h-240v10h250v-345q0 -101 36.5 -153t103.5 -52q68 0 105 53t37 156zM744 0h-10v654h-169v10h416v-10h-237v-654z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE005",
    unicode: "\uE005",
    horizAdvX: 557,
    d: "M539 664l-330 -566q-37 -62 -67.5 -80t-102.5 -18h-9v10h9q67 0 96.5 17.5t62.5 74.5l74 127l-254 435h13l248 -424l247 424h13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniE006",
    unicode: "\uE006",
    horizAdvX: 290,
    d: "M19 492h65v137h10v-137h181v-10h-181v-356q0 -49 30 -82.5t92 -33.5h36v-10h-36q-66 0 -99 36.5t-33 90.5v355h-65v10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "\uFB01",
    horizAdvX: 401,
    d: "M94 0h-10v482h-65v10h65q0 180 188 180h91v-121h-10v111h-81q-178 0 -178 -170h181v-10h-181v-482zM363 0h-10v492h10v-492z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "\uFB02",
    horizAdvX: 394,
    d: "M353 0h-10v482h-249v-482h-10v482h-65v10h65q0 180 188 180v-10q-178 0 -178 -170h249v180h10v-672z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexhook",
    horizAdvX: 490,
    d: "M290 605l-118 101l-117 -101l-5 5l115 105h15l115 -105zM363 581h-11l2 10q4 19 17 31.5t25.5 18t23 16.5t10.5 28q0 23 -15 37t-42 14q-34 0 -60 -25l-3 10q26 25 63 25q31 0 49 -16.5t18 -44.5q0 -20 -11 -33t-24.5 -18.5t-26.5 -18.5t-15 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breveacute",
    horizAdvX: 301,
    d: "M241 668h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM246 736l-148 -89l-4 6l145 92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevetilde",
    horizAdvX: 304,
    d: "M241 668h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM246 739l8 -4q-17 -47 -57 -47q-19 0 -45.5 22.5t-44.5 22.5q-31 0 -47 -42l-8 4q17 48 55 48q20 0 46.5 -22.5t43.5 -22.5q34 0 49 41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevehook",
    horizAdvX: 301,
    d: "M241 668h10q0 -54 -29.5 -84t-70.5 -30q-42 0 -71.5 30t-29.5 84h10q0 -51 27.5 -77.5t63.5 -26.5q37 0 63.5 26t26.5 78zM148 623h-11l2 10q5 20 28 36t23 32t-10.5 25.5t-28.5 9.5q-22 0 -44 -19l-3 10q19 19 47 19q22 0 35.5 -12.5t13.5 -32.5q0 -19 -12 -28 t-25 -19.5t-15 -30.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflexacute",
    horizAdvX: 536,
    d: "M472 706l-160 -101l-4 6l157 104zM295 610l-5 -5l-117 101l-118 -101l-5 5l115 105h15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecircumflex",
    horizAdvX: 536,
    d: "M600 605l-160 101l7 9l157 -104zM481 605l-118 101l-117 -101l-5 5l115 105h15l115 -105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CR",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brevegrave",
    horizAdvX: 301,
    d: "M241 668h10q0 -54 -29.5 -84t-71.5 -30q-41 0 -70.5 30t-29.5 84h10q0 -52 26.5 -78t63.5 -26q36 0 63.5 26.5t27.5 77.5zM203 647l-148 89l7 9l145 -92z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF6",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EB0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAE",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EAA",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EA0",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E92",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E85",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E83",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E81",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E6C",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B3",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04B2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u04A0",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0497",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0496",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0436",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u042A",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0416",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u040B",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0402",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u03B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u039B",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0394",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0237",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017D",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u017B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0179",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0175",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0104",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0102",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0100",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xC1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "x",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "w",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "j",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Z",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 191
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0237",
    k: -215
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "j",
    k: -215
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "\u0427",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\uE005",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "\u042F",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "J",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "7",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "1",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "&",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0427",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE004",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE001",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\uE000",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2026",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201E",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u201A",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2014",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u2013",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EF1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEF",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EED",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EEB",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE3",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE1",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EE0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDF",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDE",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDD",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDB",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EDA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED9",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED7",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED5",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED3",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED1",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ED0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECF",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECE",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECD",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1ECC",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC7",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC5",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC3",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EC1",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBF",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBD",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EBB",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB9",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB7",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB6",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB4",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB2",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EB0",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAF",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAE",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAD",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAC",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAB",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EAA",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA9",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA8",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA7",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA6",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA4",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA2",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1EA0",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E93",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E85",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E83",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E81",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E63",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E62",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E5B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E4B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E45",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E13",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u1E0D",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0512",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04EF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E9",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04E8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04C4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B3",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AB",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04AA",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04A1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u049B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0497",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0491",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u045A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0454",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0453",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0449",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0448",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0446",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0442",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043F",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u043C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0439",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0438",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0433",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0432",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042D",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u041B",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0409",
    k: 165
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0404",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CD",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03CC",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C6",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C3",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03C2",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B5",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03B1",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AE",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AD",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03AC",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u039B",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0398",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0272",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0237",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F9",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F5",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01F4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E7",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01E6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01DD",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01B0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A1",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u01A0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017E",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017C",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u017A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0177",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0175",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0173",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0171",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016F",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u016B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0169",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0161",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0160",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015F",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015E",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015B",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u015A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0159",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0157",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0155",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0153",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0152",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0151",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0150",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014F",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014D",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u014B",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0148",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0146",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0144",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0123",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0122",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0121",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0120",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011F",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011E",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u011B",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0119",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0117",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0115",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0113",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0111",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010F",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010D",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010B",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u010A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0107",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0106",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0105",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0104",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0103",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0102",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0101",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0100",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFB",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xFA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF8",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF6",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF5",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF4",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF3",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF2",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEB",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xEA",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE9",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE8",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE7",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE5",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE3",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xE0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD8",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD5",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD4",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD3",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xD2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC6",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC5",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC4",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC2",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xC1",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "z",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "y",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "x",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "w",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "u",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "s",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "r",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "q",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "p",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "o",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "n",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "m",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "j",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "g",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "e",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "d",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "c",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "a",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "S",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "Q",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "O",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "G",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "C",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "A",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ".",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "-",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: ",",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "J",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "&",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2026",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201E",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u201A",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2019",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\u2018",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ".",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ",",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "'",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\"",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2014",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\u2013",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "-",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "8",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "2",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2026",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201E",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201D",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201C",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u201A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2019",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\u2018",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ".",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: ",",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "'",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\"",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201D",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u201C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2019",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2018",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2014",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\u2013",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "-",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "'",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\"",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "1",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2026",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u201A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2014",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2013",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ".",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "-",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: ",",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2026",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201D",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201C",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u201A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2019",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2018",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2014",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\u2013",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ".",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "-",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: ",",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "'",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "\"",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "7",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\uE002",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2039",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2026",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201E",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201C",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u201A",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2019",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2018",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2014",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2013",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB6",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB4",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB2",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB0",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAE",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAC",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAA",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA8",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA6",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA4",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA2",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA0",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u039B",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0394",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0104",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0102",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0100",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC6",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC5",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC4",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC2",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC1",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xAB",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "A",
    k: 187
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ".",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "-",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: ",",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "'",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\"",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "8",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "7",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "2",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2026",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201E",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201C",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u201A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2019",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2018",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2014",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\u2013",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ".",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "-",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: ",",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "'",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "\"",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0237",
    k: -141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u01F5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u01E7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0123",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u0121",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "\u011F",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "j",
    k: -141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "g",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0427",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0417",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u03BB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "J",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE004",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE003",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE002",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE001",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\uE000",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u203A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2039",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2014",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2013",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EED",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EEB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EE0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EDA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ED0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECE",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1ECC",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EBB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB6",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB4",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EB0",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAF",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAE",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAC",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EAA",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA9",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA8",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA6",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA4",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EA0",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E93",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E6C",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E63",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E5B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E4B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E45",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E13",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E0D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04EF",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04E8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04C4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04AA",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u04A0",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u049B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0499",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0491",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u045A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0454",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0453",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u044B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0449",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0448",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0446",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u043C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0439",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0438",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0437",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0433",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0432",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u042A",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u040B",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0404",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0402",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03CC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03C2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03BA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u03AC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u039B",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0398",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0394",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0272",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0237",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01F4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01E6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01DD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01B0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01A0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017E",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017C",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u017A",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0164",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0162",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015B",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0152",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0150",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0148",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0146",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0144",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0122",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0120",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010A",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0106",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD8",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD3",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xBB",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xAB",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "z",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "j",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "T",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "Q",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "O",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "G",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 125
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "-",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u2026",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u201A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EB0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EAE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EAC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EAA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u1EA0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u039B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0394",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0104",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0102",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\u0100",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "\xC1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ".",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: ",",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "J",
    u2: "/",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\uE006",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "&",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "?",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2014",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2013",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF6",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EF2",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB6",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB4",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB2",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EB0",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAE",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAD",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAC",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EAA",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA8",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA6",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA4",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA2",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1EA0",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E92",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E84",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E82",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E80",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u1E63",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u04B2",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0496",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0416",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u039B",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0394",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01F5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01E7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u017B",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0179",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0178",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0176",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0174",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xDD",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Z",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "Y",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "W",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "-",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\uE005",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03C1",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03BB",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u03B6",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "&",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03C1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03B8",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u03A9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "/",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE004",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE003",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE002",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE001",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE000",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u203A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2039",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF1",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEF",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EED",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EEB",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE9",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE7",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE5",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE2",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EE0",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDF",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDE",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDC",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EDA",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED8",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED6",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED4",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED2",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ED0",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECF",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECE",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1ECC",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EC1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBF",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EBB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB7",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB6",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB4",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB2",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB1",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EB0",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAF",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAE",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAD",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAC",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAB",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EAA",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA9",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA8",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA7",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA6",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA4",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA2",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA1",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EA0",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E93",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E85",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E83",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E81",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E63",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E62",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E5B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E4B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E45",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E13",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1E0D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04EF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04E8",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C8",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04C4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04B3",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04AA",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u04A3",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u049B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0499",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0497",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0491",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045F",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045E",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045D",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045C",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u045A",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0454",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0453",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044E",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044D",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044C",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u044B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0449",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0448",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0446",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043F",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043D",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u043C",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0439",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0438",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0437",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0436",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0433",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0432",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0404",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CD",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03CC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C8",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C6",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C5",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03C2",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03BA",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B7",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03B1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AE",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u03AC",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u039B",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0398",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0394",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0272",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F9",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F5",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01F4",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E7",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01E6",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01DD",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01B0",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01A0",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017E",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017C",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u017A",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0175",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015B",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0148",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0146",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0144",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF1",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xBB",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAB",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "z",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "w",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 194
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "f",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\uE006",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0417",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03C7",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B8",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03B6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u03A6",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "&",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0237",
    k: -190
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "j",
    k: -190
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\uE006",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ";",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ":",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0237",
    k: -195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "?",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "\u0237",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "i",
    u2: "j",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "k",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "\u0237",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "l",
    u2: "j",
    k: -58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u2026",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u201E",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u201A",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1EF7",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1EF3",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1E5B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1E4B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u1E45",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04EF",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04C8",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04C4",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u04A3",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u049B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0491",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045F",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045E",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045D",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045C",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u045A",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0453",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u044E",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u044C",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u044B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0449",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0448",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0446",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u043F",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u043D",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u043C",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0439",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0438",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0433",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0432",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u03BA",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u03B7",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u03AE",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0272",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0237",
    k: -275
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u01F9",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u01F5",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u01E7",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0177",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0159",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0157",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0155",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u014B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0148",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0146",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0144",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0123",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u0121",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\u011F",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xFD",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "\xF1",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "y",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "r",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "p",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "n",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "m",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -275
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "g",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: ".",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: ",",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "l",
    k: -68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "f",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u03C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "\u03BB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "/",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0431",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\u0237",
    k: -186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "j",
    k: -186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\u0237",
    k: -195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "j",
    k: -195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "J",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u042F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0427",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE0",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE2",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE3",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE5",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0101",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0103",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011B",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\uE006",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "&",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0137",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "?",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "?",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u03C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "\u03BB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "/",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "\u03C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "\u03BB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "/",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u03C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "\u03BB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "/",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015B",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015F",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0161",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03C1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03B8",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u03A9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "/",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03C1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03B8",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u03A9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "/",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0167",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0175",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0179",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017B",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01DD",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01E6",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "V",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "K",
    k: -59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F9",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u024C",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0272",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0386",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038C",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038E",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u038F",
    u2: "\u03B6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0512",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u04B2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0498",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0496",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u042D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u041B",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0416",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0414",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0409",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u042F",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u0417",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0393",
    u2: "\u03A6",
    k: 202
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0398",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u039B",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A3",
    u2: "\u04A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A3",
    u2: "\u044A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A3",
    u2: "\u0442",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A3",
    u2: "\u03C4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u1E6C",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0512",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04B2",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u04A0",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0496",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u042A",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u041B",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0416",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0414",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u040B",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0409",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0402",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0164",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0162",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "X",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "T",
    k: 172
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0427",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A6",
    u2: "\u0417",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB4",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB2",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EB0",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAE",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAC",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EAA",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA4",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA2",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u1EA0",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u04B2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0496",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0416",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u039B",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0394",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0104",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0102",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u0100",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC5",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC4",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC2",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\xC1",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "A",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03C1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03BB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A8",
    u2: "\u03B6",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03A9",
    u2: "\u03B6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AC",
    u2: "\u03C7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AC",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AD",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AE",
    u2: "\u04A1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AE",
    u2: "\u044A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AE",
    u2: "\u0442",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AE",
    u2: "\u03C4",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AF",
    u2: "\u03C7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03AF",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B1",
    u2: "\u03C7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B1",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B3",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B5",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\uE001",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EF1",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEF",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EED",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EEB",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE9",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE7",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE3",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EE1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDF",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDD",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EDB",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED9",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED7",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED5",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED3",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ED1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECF",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1ECD",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC7",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC5",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC3",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EC1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBF",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBD",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EBB",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1EB9",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E85",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E83",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E81",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E5B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E4B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E45",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E13",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u1E0D",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04E9",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C8",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04C4",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04B2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04AB",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u04A3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u049B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0496",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0491",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045C",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u045A",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0454",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0453",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044E",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044C",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u044B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0449",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0448",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0446",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043F",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043D",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u043C",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0439",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0438",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0433",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0432",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0416",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CE",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CD",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CC",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03CA",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C9",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C8",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C6",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C3",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C2",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BA",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B9",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B5",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B3",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AF",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AE",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AD",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03AC",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0272",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01F9",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01DD",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01B0",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u01A1",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0175",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0173",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0171",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016F",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016D",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u016B",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0169",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0159",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0157",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0155",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0153",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0151",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014F",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014D",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u014B",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0148",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0146",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0144",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u011B",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0119",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0117",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0115",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0113",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0111",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010F",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010D",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u010B",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u0107",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFC",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFB",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xFA",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF9",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF8",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF6",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF5",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF4",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF3",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF2",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xF0",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEB",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xEA",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE9",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE8",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\xE7",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "w",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "v",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "u",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "r",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "q",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "p",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "o",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "n",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "m",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "e",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "d",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "c",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03C7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03BB",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B6",
    u2: "\u03B8",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B9",
    u2: "\u03C7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03B9",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BA",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\uE001",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201D",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u201C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2019",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u2018",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EF1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEF",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EED",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EEB",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE7",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EE1",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDD",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EDB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ED1",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1ECD",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EC1",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBF",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBD",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EBB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1EB9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E85",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E83",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E81",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E13",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u1E0D",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04E9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04AB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u04A1",
    k: 192
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0454",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u044A",
    k: 192
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0442",
    k: 192
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03CA",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C8",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C6",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C5",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C4",
    k: 192
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B3",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B1",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AF",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AD",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03AC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01DD",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01B0",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u01A1",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0175",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0173",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0171",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016F",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016D",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u016B",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0169",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0153",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0151",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014F",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u014D",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u011B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0119",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0117",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0115",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0113",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0111",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010F",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010D",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u010B",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u0107",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFC",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFB",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xFA",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF9",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF6",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF4",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF3",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF2",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xF0",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEB",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xEA",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE9",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\xE7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "w",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "v",
    k: 161
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "u",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "q",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "o",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "e",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "d",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "c",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "'",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\"",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03C7",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BB",
    u2: "\u03B8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\uE002",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\u2039",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BE",
    u2: "\xAB",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E85",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E83",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u1E81",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B3",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u0175",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "w",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "v",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C2",
    u2: "\u03B6",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\uE001",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EE1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EDB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ED1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1ECD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EC1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBF",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EBB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1EB9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E13",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u1E0D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04E9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04AB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u04A1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0454",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u044A",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03CE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03CC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C9",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C4",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03C2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u03AC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01DD",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u01A1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0153",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0151",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014F",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u014D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u011B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0119",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0117",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0115",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0113",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0111",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010F",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010D",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u010B",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\u0107",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF4",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF2",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xF0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEB",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xEA",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE9",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE8",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "\xE7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "q",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "o",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "e",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "d",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C3",
    u2: "c",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\uE001",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EE1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDD",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EDB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ED1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1ECD",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EC1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBF",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBD",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EBB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1EB9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E13",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u1E0D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04E9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u04AB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0454",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03CC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03C2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03B1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AD",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u03AC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01DD",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u01A1",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0153",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0151",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u014D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u011B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0119",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0117",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0115",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0113",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0111",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010F",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010D",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u010B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\u0107",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xF0",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEB",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xEA",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE9",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "\xE7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "q",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "o",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "e",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "d",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C4",
    u2: "c",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C6",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\uE001",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EE1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDF",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDD",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EDB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED9",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED5",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ED1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECF",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1ECD",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC5",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EC1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBF",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBD",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EBB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1EB9",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E13",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u1E0D",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04E9",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u04AB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0454",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CE",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CC",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03CA",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C9",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C6",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03C2",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B5",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AF",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AD",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03AC",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01DD",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u01A1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0153",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0151",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014F",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u014D",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u011B",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0119",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0117",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0115",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0113",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0111",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010F",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010D",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u010B",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u0107",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF8",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF6",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF5",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF4",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF3",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF2",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xF0",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xEA",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE9",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE8",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\xE7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "q",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "o",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "e",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "d",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "c",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03BB",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C7",
    u2: "\u03B6",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03C7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C9",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CA",
    u2: "\u03C7",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CA",
    u2: "\u03C0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CC",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03C7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03CE",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0427",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "\u0417",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "?",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0409",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0427",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "\u0417",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "?",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040A",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "\uE006",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040C",
    u2: "&",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u1E6C",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0512",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B2",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04A0",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0498",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0496",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042D",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042A",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u041B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0416",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u040B",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0409",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0402",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0164",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0162",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "X",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "T",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0427",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0417",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\uE006",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0417",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03C7",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B8",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03B6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u03A6",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "J",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "?",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "&",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0427",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0417",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u03BB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "J",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0427",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "\u0417",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "?",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042A",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u042F",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0427",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "\u0417",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "?",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042C",
    u2: "/",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042D",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u042E",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0513",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B3",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04A1",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0497",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0459",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u043B",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u03C4",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "x",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044F",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0447",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0513",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04A1",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0497",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0459",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u044A",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u043B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0436",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u03C4",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0447",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "\u03BB",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0433",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u03BB",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044A",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044C",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044D",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u044E",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "\u03BB",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0453",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0459",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045A",
    u2: "\u0447",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045C",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "\u03BB",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0491",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0496",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0497",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049A",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u049B",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "\uE006",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "f",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "J",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A0",
    u2: "&",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A1",
    u2: "&",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A2",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04A3",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "\uE005",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AA",
    u2: "/",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\uE006",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "\u03BB",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "?",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04AB",
    u2: "/",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B2",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B3",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u0417",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "\u03A6",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B6",
    u2: "?",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0447",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B7",
    u2: "\u0431",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E8",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04E9",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E12",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E25",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "V",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "?",
    k: 171
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E3C",
    u2: "&",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E45",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E4B",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "&",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "\u03C1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "\u03BB",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5B",
    u2: "/",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\uE006",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "/",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "f",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "?",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E63",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03C1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03B8",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\u03A9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "/",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "\u03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E81",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E83",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\uE006",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "J",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "?",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "/",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03C1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03BB",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "\u03B6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E85",
    u2: "/",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "\u03C7",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "?",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E92",
    u2: "&",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201D",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u201C",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2019",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u2018",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF6",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EF2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EB0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAE",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EAA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA8",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1EA0",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E84",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E82",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E80",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u1E6C",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04B2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u04A0",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0496",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u042A",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0416",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u040B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0402",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u039B",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0394",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0178",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0176",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0174",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0164",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0162",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0104",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0102",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\u0100",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xDD",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC6",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC4",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\xC1",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "Y",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "X",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "T",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "A",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "'",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "\"",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E9E",
    u2: "J",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA3",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA5",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA7",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA9",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAB",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAD",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAF",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB1",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB3",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB5",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\uE006",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u0427",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03C7",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03B8",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03B6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "\u03A8",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "f",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "V",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "J",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "?",
    k: 166
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "&",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "f",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB7",
    u2: "?",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB9",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBB",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBD",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBF",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC3",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC5",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EC7",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECD",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECF",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED3",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED5",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED7",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\uE005",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u042F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u0427",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03C7",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "\u03BB",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\uE006",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03C7",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "\u03BB",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "f",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "?",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED9",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\uE006",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u042F",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C7",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03C1",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03BB",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B8",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03B6",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\u03A9",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "/",
    k: 193
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "&",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\uE005",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "\u042F",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "J",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "7",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "1",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "&",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\uE005",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "\u042F",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "f",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "J",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "9",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "8",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "7",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "4",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "3",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "1",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "/",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "&",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "\u0427",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "J",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "4",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "/",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "\u0427",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "\u0427",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "f",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "J",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "8",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "6",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "5",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "4",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "J",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u042F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0427",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF7",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF3",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1EF2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E92",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E84",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E82",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E80",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E6C",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E5B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E4B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u1E45",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04EF",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04C8",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04C4",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04A3",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u04A0",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u049B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0491",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045F",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045E",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u045A",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0453",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u044E",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u044C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u044B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0449",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0448",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0446",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u043F",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u043D",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u043C",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0439",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0438",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0433",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0432",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u042A",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u040B",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0402",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u03BA",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u03B7",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u03AE",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0272",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0237",
    k: -433
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u01F9",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u01F5",
    k: -210
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u01E7",
    k: -210
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u017D",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u017B",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0179",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0178",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0177",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0176",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0174",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0164",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0162",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0159",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0157",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0155",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u014B",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0148",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0146",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0144",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0123",
    k: -210
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u0121",
    k: -210
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\u011F",
    k: -210
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\xFD",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\xF1",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "\xDD",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "y",
    k: -199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "r",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "p",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "n",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "m",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "j",
    k: -433
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "g",
    k: -210
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "Z",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "Y",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "W",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "T",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "K",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "8",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "6",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE000",
    u2: "0",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE002",
    u2: "J",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u042F",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "\u0427",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE003",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C7",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03C1",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03BB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03B8",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "\u03A9",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "J",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "?",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE004",
    u2: "/",
    k: 186
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE004",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE001",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\uE000",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2026",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201E",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u201A",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2014",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u2013",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF7",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF3",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EF1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEF",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EED",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EEB",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE9",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE7",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE3",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE2",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE1",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EE0",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDF",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDE",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDD",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDC",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDB",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EDA",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED9",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED8",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED7",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED6",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED5",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED4",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED3",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED2",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED1",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ED0",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECF",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECE",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECD",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1ECC",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC7",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC5",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC3",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EC1",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBF",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBD",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EBB",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB9",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB7",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB6",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB5",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB4",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB3",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB2",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB1",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EB0",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAF",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAE",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAD",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAC",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAB",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EAA",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA9",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA8",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA7",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA6",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA5",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA4",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA3",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA2",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA1",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1EA0",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E93",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E85",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E83",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E81",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E63",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E62",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E5B",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E4B",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E45",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E13",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u1E0D",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0512",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04EF",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E9",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04E8",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C8",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04C4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04B3",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AB",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04AA",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A3",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u04A1",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u049B",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0498",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0497",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0491",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045E",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045D",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045C",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u045A",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0454",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0453",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044E",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044C",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044B",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u044A",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0449",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0448",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0446",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0442",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043D",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u043C",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0439",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0438",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0436",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0433",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0432",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042D",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u041B",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0414",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0409",
    k: 185
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0404",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CD",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03CC",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C4",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C3",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03C2",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03BA",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B7",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B5",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03B1",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AE",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AD",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u03AC",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u039B",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0398",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0394",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0272",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F9",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01F4",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01E6",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01DD",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01B0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A1",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u01A0",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u018F",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017E",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017C",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u017A",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0177",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0175",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0173",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0171",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016F",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016D",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u016B",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0169",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0161",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0160",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015F",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015B",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u015A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0159",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0157",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0155",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0153",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0152",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0151",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0150",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014F",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014E",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014D",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014C",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u014B",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0148",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0146",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0144",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0122",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0120",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011E",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u011B",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0119",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0117",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0115",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0113",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0111",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010F",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010D",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010C",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010B",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u010A",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0107",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0106",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0105",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0104",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0103",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0102",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0101",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u0100",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFD",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFC",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFB",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xFA",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF9",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF8",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF6",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF5",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF4",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF3",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF2",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF1",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xF0",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEB",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xEA",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE9",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE8",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE7",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE6",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE5",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE4",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE3",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE2",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE1",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xE0",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD8",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD6",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD5",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD4",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD3",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xD2",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC7",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC6",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC5",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC4",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC2",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\xC1",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "z",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "y",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "x",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "w",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "v",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "u",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "s",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "r",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "q",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "p",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "o",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "n",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "m",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "e",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "d",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "c",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "a",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "S",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "Q",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "O",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "G",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "C",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "A",
    k: 224
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ".",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "-",
    k: 167
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: ",",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "\u042F",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE005",
    u2: "J",
    k: 199
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE006",
    u2: "\u0237",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE006",
    u2: "j",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uE006",
    u2: "f",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: "\uE006",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: "]",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: ";",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB01",
    u2: ":",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: "\uE006",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: "}",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: "]",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: ";",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\uFB02",
    u2: ":",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 214
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "hyphen,endash,emdash",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "j,dotlessj",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni042D,uni0498",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "iotatonos,iota,iotadieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "uni0437,uni044D,uni0499",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "omega,omegatonos",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Aacute,Acircumflex,Adieresis,Aring,Amacron,Abreve,Aogonek,Alphatonos,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Alphatonos,Epsilontonos,Etatonos,Iotatonos,Omicrontonos,Upsilontonos,Omegatonos",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "hyphen,endash,emdash",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "j,dotlessj",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "uni042D,uni0498",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0417",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "hyphen,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "j,dotlessj",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "uni042D,uni0498",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni04AA",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "j,dotlessj",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent,uni01E6,uni01F4",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "hyphen,endash,emdash",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni042D,uni0498",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni040C,uni04A0",
    g2: "uni0437,uni044D,uni0499",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "hyphen,endash,emdash",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 221
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,uni1E3C",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "j,dotlessj",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Oslash,Thorn,Dcaron,Omacron,Obreve,Ohungarumlaut,uni018F,Omicrontonos,Theta,uni042D,uni042E,uni04E8,uni1E0C,uni1E12,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "hyphen,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "j,dotlessj",
    k: -147
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,uni024C,uni1E5A",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "hyphen,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "j,dotlessj",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,uni1E62",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "hyphen,endash,emdash",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "j,dotlessj",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0437,uni044D,uni0499",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "omega,omegatonos",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni1E6C,uniE004",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "j,dotlessj",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 155
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "hyphen,endash,emdash",
    k: 142
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni042D,uni0498",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "iotatonos,iota,iotadieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "uni0437,uni044D,uni0499",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni0416",
    g2: "omega,omegatonos",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "hyphen,endash,emdash",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 132
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni042D,uni0498",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "iotatonos,iota,iotadieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0437,uni044D,uni0499",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "omega,omegatonos",
    k: 151
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 188
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Upsilontonos,Ygrave,uni1EF6",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,eng,racute,rcommaaccent,rcaron,uni01F9,uni0272,etatonos,eta,uni043A,uni0432,uni0433,uni0438,uni0439,uni043C,uni043D,uni043F,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni04A3,uni04C4,uni04C8,uni1E45,uni1E4B,uni1E5B",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "hyphen,endash,emdash",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "iotatonos,iota,iotadieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "uni0437,uni044D,uni0499",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "omega,omegatonos",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "j,dotlessj",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,epsilontonos,epsilon,uni0454,uni04AB",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "hyphen,endash,emdash",
    k: 127
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "j,dotlessj",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,fi,fl",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j,ij,dotlessj",
    g2: "j,dotlessj",
    k: -174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "hyphen,endash,emdash",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "j,dotlessj",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni043A,uni045C,uni04A1",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "j,dotlessj",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,h,m,n,agrave,aacute,acircumflex,atilde,adieresis,aring,ntilde,amacron,abreve,aogonek,hbar,nacute,ncommaaccent,ncaron,eng,uni01F9,uni0272,uni0452,uni1E25,uni1E45,uni1E4B,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,e,o,p,ae,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,uni01DD,rho,uni0444,omicrontonos,uni044D,uni044E,uni04E9,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "hyphen,endash,emdash",
    k: 137
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "j,dotlessj",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,uni1E5B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "hyphen,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,uni1E63",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tbar,uni1E6D",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "omega,omegatonos",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "hyphen,endash,emdash",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "j,dotlessj",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "guillemotright,guilsinglright,uniE003",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "uni0437,uni044D,uni0499",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0436",
    g2: "omega,omegatonos",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "hyphen,endash,emdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "j,dotlessj",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni1E93",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "hyphen,endash,emdash",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "j,dotlessj",
    k: -214
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "uni042D,uni0498",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429,uni0496,uni049A,uni04A2,uni04B2,uni04B6",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449,uni0497,uni049B,uni04A3,uni04B3,uni04B7",
    g2: "uni0437,uni044D,uni0499",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 216
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437,uni0499",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "omega,omegatonos",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Omegatonos,Omega",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft,uniE002",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "uni0437,uni044D,uni0499",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "omega,omegatonos",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0442,uni0453,uni0491",
    g2: "uni0434,uni043B,uni0459,uni0513",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "alphatonos,iotatonos,alpha,iota,iotadieresis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "j,dotlessj",
    k: -108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "j,dotlessj",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni042D,uni0498",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 142
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,uni018F,Ohorn,uni01E6,uni01F4,Theta,uni0404,uni04AA,uni04E8,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2,uniE000,uniE004",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni040E,uni0423,uni04EE,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "hyphen,endash,emdash",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "quotedbl,quotesingle,quoteleft,quoteright,quotedblleft,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,wcircumflex,uni04AF,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,upsilon,psi,upsilontonos,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "g,gbreve,gdotaccent,gcommaaccent,uni01E7,uni01F5",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "c,d,e,o,q,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,ohorn,uni01DD,alphatonos,epsilontonos,alpha,epsilon,sigma1,sigma,uni0444,omicrontonos,uni0454,uni04AB,uni04E9,uni1E0D,uni1E13,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3,uniE001",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "y,yacute,ycircumflex,uni045E,uni04EF,ygrave,uni1EF7",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "j,dotlessj",
    k: -183
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "s,sacute,scedilla,scaron,uni1E63",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,tcommaaccent,tcaron,tbar,uni1E6D",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "uni042D,uni0498",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "tau,uni0442,uni044A,uni04A1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft,uniE002",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "T,Tcommaaccent,Tcaron,uni0402,uni040B,uni042A,uni04A0,uni1E6C",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "S,Sacute,Scedilla,Scaron,uni1E62",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,uni1EF6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "j,dotlessj",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "A,Aacute,Acircumflex,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Delta,Lambda,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "X,uni0416,uni0496,uni04B2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "uni0409,uni0414,uni041B,uni0512",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni1E92",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "x,uni0436,uni0497,uni04B3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright,uniE003",
    g2: "z,zacute,zdotaccent,zcaron,uni1E93",
    k: 84
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoolveticaUlRegular);
export default __webpack_public_path__ + "static/media/CoolveticaUl-Regular.90617dd14181621cf634aa5b69b03c7b.svg";
export { ForwardRef as ReactComponent };